import AdvancedAdvertisementBanner from './AdvancedAdvertisementBanner';
import AdvancedAdvertisementManager from './AdvancedAdvertisementManager';
import GovernanceStrategySectionPro from './GovernanceStrategySectionPro';
import HelpCenterPage from './pages/organization/HelpCenterPage';
import SupportPage from './pages/organization/SupportPage';
import SupportTicketDetailPage from './pages/organization/SupportTicketDetailPage';
import React, { useState, useEffect, createContext, useContext, Suspense, lazy, useMemo } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation, Navigate, useNavigate, useOutletContext } from "react-router-dom";

// Platform Settings Context - سيتم استخدام الـ Context المستورد
import 'react-quill/dist/quill.snow.css';
import axios from "axios";
import TournamentsSection from './TournamentsSection';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import "./App.css";
import EnhancedReportsSection from './components/reports/EnhancedReportsSection';
import EnhancedSocialMediaManager from './EnhancedSocialMediaManager';
import UnifiedPlayersSection from './components/reports/UnifiedPlayersSection';
import ProfessionalMatchesComponent from './MatchesComponent';
import UnifiedReportsSettings from './components/reports/UnifiedReportsSettings';
import ContactUsModal from './components/ui/ContactUsModal';
import { EmailVerificationPrompt } from './components/auth/EmailVerificationPrompt';
import { MandatoryEmailVerificationGate } from './components/auth/MandatoryEmailVerificationGate';
import { Toaster } from './components/ui/Toaster';
import EnhancedPlayersComponent from './EnhancedPlayersComponent';
import ProfessionalReportsSection from './components/reports/ProfessionalReportsSection';
import UnifiedAdvancedReportsSection from './components/reports/UnifiedAdvancedReportsSection';
import BoardManagementSection from './components/management/BoardManagementSection';
import BoardOfDirectorsSection from './components/management/BoardOfDirectorsSection';
import SimpleTeamsComponent from './SimpleTeamsComponent';

// New SaaS components
import LandingPage from './pages/LandingPage';
import EmployeeVerifyPage from './pages/EmployeeVerifyPage';
import UltimateSuperAdmin from './UltimateSuperAdmin';
import EnhancedProfessionalLogin from './pages/EnhancedProfessionalLogin';
import RegisterPage from './pages/RegisterPage';
import BookingStatusPage from './pages/BookingStatusPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import UpdatesPage from './pages/UpdatesPage';

// Communication and Notification components
import ChatWidget from './ChatWidget';
import PublicFaqWidget from './PublicFaqWidget';
import ClubIdentityManager from './components/ClubIdentityManager';
import DynamicClubStyles from './components/DynamicClubStyles';
import LanguageSelector from './components/ui/LanguageSelector';
import DynamicPageTitle from './components/ui/DynamicPageTitle';
import PlatformContext from './contexts/PlatformContext';
import OrganizationDashboard from './pages/dashboard/OrganizationDashboard';
import OrganizationShell from './layouts/OrganizationShell';
import VenueOwnerShell from './layouts/VenueOwnerShell';
import VenueOwnerHomePage from './pages/venue-owner/VenueOwnerHomePage';
import VenueOwnerBookingsPage from './pages/venue-owner/VenueOwnerBookingsPage';
import VenueOwnerCalendarPage from './pages/venue-owner/VenueOwnerCalendarPage';
import VenueOwnerVenuesPage from './pages/venue-owner/VenueOwnerVenuesPage';
import VenueOwnerCustomersPage from './pages/venue-owner/VenueOwnerCustomersPage';
import VenueOwnerReportsPage from './pages/venue-owner/VenueOwnerReportsPage';
import VenueOwnerNotificationsPage from './pages/venue-owner/VenueOwnerNotificationsPage';
import VenueOwnerPublicPagePage from './pages/venue-owner/VenueOwnerPublicPagePage';
import VenueOwnerSubscriptionPage from './pages/venue-owner/VenueOwnerSubscriptionPage';
import VenueOwnerSettingsPage from './pages/venue-owner/VenueOwnerSettingsPage';
import EmployeesPage from './pages/organization/EmployeesPage';
import FinanceSummaryPage from './pages/organization/finance/FinanceSummaryPage';
import FinanceHubPage from './pages/organization/finance/FinanceHubPage';
import TransactionsPage from './pages/organization/finance/TransactionsPage';
import InvoicesPage from './pages/organization/finance/InvoicesPage';
import QuotesPage from './pages/organization/finance/QuotesPage';
import BudgetPage from './pages/organization/finance/BudgetPage';
import PayrollPage from './pages/organization/finance/PayrollPage';
import FinanceReportsPage from './pages/organization/finance/FinanceReportsPage';
import TeamsPage from './pages/organization/TeamsPage';
import TournamentsPage from './pages/organization/TournamentsPage';
import CoachShell from './layouts/CoachShell';
import CoachDashboardPage from './pages/coach/CoachDashboardPage';
import CoachProfilePage from './pages/coach/CoachProfilePage';
import CoachRequestsPage from './pages/coach/CoachRequestsPage';
import CoachOrganizationsPage from './pages/coach/CoachOrganizationsPage';
import CoachCrewPage from './pages/coach/CoachCrewPage';
import CoachRecruitmentPage from './pages/organization/coach/CoachRecruitmentPage';
import StudioDashboardPage from './pages/coach/studio/StudioDashboardPage';
import ExerciseLibraryPage from './pages/coach/studio/ExerciseLibraryPage';
import ExerciseEditorPage from './pages/coach/studio/ExerciseEditorPage';
import TrainingPlansPage from './pages/coach/studio/TrainingPlansPage';
import PlanDetailPage from './pages/coach/studio/PlanDetailPage';
import TrainingSchedulePage from './pages/coach/studio/TrainingSchedulePage';
import StudioReportsPage from './pages/coach/studio/StudioReportsPage';
import SharedCoachingHubPage from './pages/organization/studio/SharedCoachingHubPage';
import CoachesLandingPage from './pages/CoachesLandingPage';
import CoachDirectoryPage from './pages/CoachDirectoryPage';
import CoachRegisterPage from './pages/CoachRegisterPage';
import ContactUsPage from './pages/ContactUsPage';
import ReportsPage from './pages/organization/ReportsPage';
import PlayersPage from './pages/organization/PlayersPage';
import SubscriptionPlansPage from './pages/organization/SubscriptionPlansPage';
import VenueManagementPage from './pages/organization/venue-booking/VenueManagementPage';
import VenuesPublicPage from './pages/VenuesPublicPage';
import MatchesPage from './pages/organization/MatchesPage';
import AttendancePage from './pages/organization/AttendancePage';
import SettingsPage from './pages/organization/SettingsPage';
import IntegrationsPage from './pages/organization/IntegrationsPage';
import BoardPage from './pages/organization/BoardPage';
import GovernancePage from './pages/organization/GovernancePage';
import PerformanceReviewPage from './pages/organization/PerformanceReviewPage';
import ActivityLogPage from './pages/organization/ActivityLogPage';
import SuperAdminPage from './pages/SuperAdminPage';
import ParentShell from './layouts/ParentShell';
import ParentHomePage from './pages/parent/ParentHomePage';
import ParentChildrenPage from './pages/parent/ParentChildrenPage';
import ParentChildDetailPage from './pages/parent/ParentChildDetailPage';
import ParentExplorePage from './pages/parent/ParentExplorePage';
import ParentPaymentsPage from './pages/parent/ParentPaymentsPage';
import ParentAccountPage from './pages/parent/ParentAccountPage';
import ParentInvitePage from './pages/parent/ParentInvitePage';
import ParentLinkRequestsPage from './pages/organization/ParentLinkRequestsPage';
import CommunicationPage from './pages/organization/CommunicationPage';
import ProgramsPage from './pages/organization/ProgramsPage';

// Global helper functions
const showNotification = (message, type = 'info') => {
  const notification = document.createElement('div');
  const bgColor = type === 'success' ? 'bg-green-500' : type === 'error' ? 'bg-red-500' : 'bg-blue-500';
  notification.className = `fixed top-4 right-4 ${bgColor} text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-pulse`;
  notification.innerHTML = `<div class="flex items-center">${message}</div>`;
  document.body.appendChild(notification);
  setTimeout(() => {
    if (document.body.contains(notification)) {
      document.body.removeChild(notification);
    }
  }, 4000);
};

// Staff Management Components
const StaffAdminComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-6xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">👔</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">الموظفين الإداريين</h1>
              <p className="text-gray-600">إدارة الموظفين الإداريين والمكتبيين</p>
            </div>
          </div>
          <button className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-lg hover:shadow-lg transition-all">
            ➕ إضافة موظف جديد
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { name: 'أحمد محمد', position: 'مدير إداري', department: 'الإدارة العامة', phone: '0501234567', email: 'ahmed@club.com' },
            { name: 'فاطمة سالم', position: 'محاسبة', department: 'الشؤون المالية', phone: '0501234568', email: 'fatima@club.com' },
            { name: 'خالد العلي', position: 'مسؤول العلاقات العامة', department: 'الإعلام', phone: '0501234569', email: 'khalid@club.com' }
          ].map((staff, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-200/50 hover:shadow-lg transition-all">
              <div className="flex items-center space-x-3 space-x-reverse mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white font-bold">
                  {staff.name.charAt(0)}
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">{staff.name}</h3>
                  <p className="text-sm text-gray-600">{staff.position}</p>
                </div>
              </div>
              <div className="space-y-2 text-sm text-gray-600">
                <p>🏢 {staff.department}</p>
                <p>📱 {staff.phone}</p>
                <p>📧 {staff.email}</p>
              </div>
              <div className="flex space-x-2 space-x-reverse mt-4">
                <button className="flex-1 bg-blue-50 text-blue-600 py-2 rounded-lg text-sm hover:bg-blue-100 transition-colors">تعديل</button>
                <button className="flex-1 bg-green-50 text-green-600 py-2 rounded-lg text-sm hover:bg-green-100 transition-colors">عرض</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const CoachingStaffComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-6xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">🏃‍♂️</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">الطاقم التدريبي</h1>
              <p className="text-gray-600">إدارة المدربين ومساعديهم</p>
            </div>
          </div>
          <button className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-lg hover:shadow-lg transition-all">
            ➕ إضافة مدرب جديد
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { name: 'كارلوس مانويل', position: 'المدرب الأول', team: 'الفريق الأول', experience: '15 سنة', nationality: 'الأرجنتين' },
            { name: 'سعد الفهد', position: 'مساعد المدرب', team: 'الفريق الأول', experience: '8 سنوات', nationality: 'السعودية' },
            { name: 'محمد رضا', position: 'مدرب الشباب', team: 'فريق الشباب', experience: '5 سنوات', nationality: 'المغرب' }
          ].map((coach, index) => (
            <div key={index} className="bg-gradient-to-br from-green-50 to-white rounded-xl p-6 border border-green-200/50 hover:shadow-lg transition-all">
              <div className="flex items-center space-x-3 space-x-reverse mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center text-white font-bold">
                  {coach.name.charAt(0)}
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">{coach.name}</h3>
                  <p className="text-sm text-green-600 font-medium">{coach.position}</p>
                </div>
              </div>
              <div className="space-y-2 text-sm text-gray-600">
                <p>⚽ {coach.team}</p>
                <p>📅 خبرة: {coach.experience}</p>
                <p>🌍 {coach.nationality}</p>
              </div>
              <div className="flex space-x-2 space-x-reverse mt-4">
                <button className="flex-1 bg-green-50 text-green-600 py-2 rounded-lg text-sm hover:bg-green-100 transition-colors">عرض السيرة</button>
                <button className="flex-1 bg-blue-50 text-blue-600 py-2 rounded-lg text-sm hover:bg-blue-100 transition-colors">إحصائيات</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const MedicalStaffComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-6xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-red-500 to-red-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">⚕️</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">الطاقم الطبي</h1>
              <p className="text-gray-600">إدارة الأطباء والمعالجين الطبيعيين</p>
            </div>
          </div>
          <button className="bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-3 rounded-lg hover:shadow-lg transition-all">
            ➕ إضافة طبيب جديد
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { 
              name: 'د. محمد الأحمد', 
              position: 'طبيب الفريق', 
              specialty: 'طب الرياضة', 
              phone: '0501234570',
              availability: 'متاح 24/7',
              cases: 45
            },
            { 
              name: 'أحمد الفيصل', 
              position: 'معالج طبيعي', 
              specialty: 'العلاج الطبيعي الرياضي', 
              phone: '0501234571',
              availability: 'السبت - الخميس',
              cases: 32
            }
          ].map((medical, index) => (
            <div key={index} className="bg-gradient-to-br from-red-50 to-white rounded-xl p-6 border border-red-200/50 hover:shadow-lg transition-all">
              <div className="flex items-center space-x-3 space-x-reverse mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-red-500 to-pink-500 rounded-full flex items-center justify-center text-white font-bold">
                  {medical.name.charAt(0)}
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">{medical.name}</h3>
                  <p className="text-sm text-red-600 font-medium">{medical.position}</p>
                </div>
              </div>
              <div className="space-y-2 text-sm text-gray-600 mb-4">
                <p>🩺 {medical.specialty}</p>
                <p>📱 {medical.phone}</p>
                <p>⏰ {medical.availability}</p>
                <p>📊 {medical.cases} حالة هذا الشهر</p>
              </div>
              <div className="flex space-x-2 space-x-reverse">
                <button className="flex-1 bg-red-50 text-red-600 py-2 rounded-lg text-sm hover:bg-red-100 transition-colors">جدولة موعد</button>
                <button className="flex-1 bg-blue-50 text-blue-600 py-2 rounded-lg text-sm hover:bg-blue-100 transition-colors">الملف الطبي</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

// Financial Management Components
const AccountsComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">📊</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">الحسابات المالية</h1>
              <p className="text-gray-600">إدارة الحسابات المالية للنادي</p>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-xl p-6 text-white">
            <h3 className="text-lg font-semibold mb-2">إجمالي الأصول</h3>
            <p className="text-3xl font-bold">2,847,500 ر.س</p>
            <p className="text-green-200 text-sm mt-1">↗️ +12% من الشهر الماضي</p>
          </div>
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl p-6 text-white">
            <h3 className="text-lg font-semibold mb-2">الأموال المتاحة</h3>
            <p className="text-3xl font-bold">845,230 ر.س</p>
            <p className="text-blue-200 text-sm mt-1">💰 متاح للصرف</p>
          </div>
          <div className="bg-gradient-to-r from-purple-500 to-purple-600 rounded-xl p-6 text-white">
            <h3 className="text-lg font-semibold mb-2">الاستثمارات</h3>
            <p className="text-3xl font-bold">1,234,800 ر.س</p>
            <p className="text-purple-200 text-sm mt-1">📈 +8% عائد سنوي</p>
          </div>
        </div>

        <div className="bg-gray-50 rounded-xl p-6">
          <h3 className="text-xl font-bold text-gray-800 mb-4">الحسابات البنكية</h3>
          <div className="space-y-3">
            {[
              { bank: 'البنك الأهلي السعودي', account: '****1234', balance: '654,320 ر.س', type: 'جاري' },
              { bank: 'بنك الرياض', account: '****5678', balance: '190,910 ر.س', type: 'توفير' },
              { bank: 'بنك ساب', account: '****9012', balance: '45,000 ر.س', type: 'جاري' }
            ].map((account, index) => (
              <div key={index} className="bg-white rounded-lg p-4 flex items-center justify-between">
                <div>
                  <h4 className="font-semibold text-gray-800">{account.bank}</h4>
                  <p className="text-sm text-gray-600">رقم الحساب: {account.account} • {account.type}</p>
                </div>
                <div className="text-right">
                  <p className="font-bold text-green-600">{account.balance}</p>
                  <button className="text-blue-600 text-sm hover:underline">عرض التفاصيل</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

const ExpensesComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-red-500 to-red-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">💸</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">المصروفات</h1>
              <p className="text-gray-600">تتبع وإدارة جميع المصروفات</p>
            </div>
          </div>
          <button className="bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-3 rounded-lg hover:shadow-lg transition-all">
            ➕ إضافة مصروف جديد
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-gradient-to-r from-red-500 to-red-600 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">المصروفات اليوم</h3>
            <p className="text-2xl font-bold">15,240 ر.س</p>
          </div>
          <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">هذا الأسبوع</h3>
            <p className="text-2xl font-bold">89,350 ر.س</p>
          </div>
          <div className="bg-gradient-to-r from-amber-500 to-amber-600 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">هذا الشهر</h3>
            <p className="text-2xl font-bold">324,780 ر.س</p>
          </div>
          <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">هذا العام</h3>
            <p className="text-2xl font-bold">2,847,650 ر.س</p>
          </div>
        </div>

        <div className="bg-gray-50 rounded-xl p-6">
          <h3 className="text-xl font-bold text-gray-800 mb-4">آخر المصروفات</h3>
          <div className="space-y-3">
            {[
              { description: 'رواتب الموظفين - سبتمبر', amount: '125,000 ر.س', date: '2024-09-01', category: 'رواتب', status: 'مدفوع' },
              { description: 'صيانة الملعب الرئيسي', amount: '8,500 ر.س', date: '2024-09-13', category: 'صيانة', status: 'مدفوع' },
              { description: 'معدات رياضية جديدة', amount: '12,300 ر.س', date: '2024-09-12', category: 'معدات', status: 'معلق' },
              { description: 'فاتورة الكهرباء', amount: '3,200 ر.س', date: '2024-09-10', category: 'مرافق', status: 'مدفوع' }
            ].map((expense, index) => (
              <div key={index} className="bg-white rounded-lg p-4 flex items-center justify-between">
                <div>
                  <h4 className="font-semibold text-gray-800">{expense.description}</h4>
                  <p className="text-sm text-gray-600">{expense.category} • {expense.date}</p>
                </div>
                <div className="text-right">
                  <p className="font-bold text-red-600">{expense.amount}</p>
                  <span className={`inline-block px-2 py-1 rounded-full text-xs ${
                    expense.status === 'مدفوع' ? 'bg-green-100 text-green-600' : 'bg-yellow-100 text-yellow-600'
                  }`}>
                    {expense.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

// Additional Staff Components
const SecurityStaffComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-6xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-gray-600 to-gray-700 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">🛡️</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">الأمن والحراسة</h1>
              <p className="text-gray-600">إدارة موظفي الأمن والحراسة</p>
            </div>
          </div>
          <button className="bg-gradient-to-r from-gray-600 to-gray-700 text-white px-6 py-3 rounded-lg hover:shadow-lg transition-all">
            ➕ إضافة حارس جديد
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { name: 'عبدالله السالم', shift: 'الوردية الصباحية', area: 'المدخل الرئيسي', phone: '0501234572' },
            { name: 'محمد العتيبي', shift: 'الوردية المسائية', area: 'الملاعب', phone: '0501234573' },
            { name: 'أحمد القحطاني', shift: 'الوردية الليلية', area: 'المبنى الإداري', phone: '0501234574' }
          ].map((guard, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-200/50 hover:shadow-lg transition-all">
              <div className="flex items-center space-x-3 space-x-reverse mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-gray-600 to-gray-700 rounded-full flex items-center justify-center text-white font-bold">
                  {guard.name.charAt(0)}
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">{guard.name}</h3>
                  <p className="text-sm text-gray-600">{guard.shift}</p>
                </div>
              </div>
              <div className="space-y-2 text-sm text-gray-600 mb-4">
                <p>🏢 {guard.area}</p>
                <p>📱 {guard.phone}</p>
                <p>🕐 {guard.shift}</p>
              </div>
              <div className="flex space-x-2 space-x-reverse">
                <button className="flex-1 bg-gray-50 text-gray-600 py-2 rounded-lg text-sm hover:bg-gray-100 transition-colors">تعديل الوردية</button>
                <button className="flex-1 bg-green-50 text-green-600 py-2 rounded-lg text-sm hover:bg-green-100 transition-colors">تقرير</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const GeneralServicesComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-6xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-amber-500 to-amber-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">⚙️</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">الخدمات العامة</h1>
              <p className="text-gray-600">إدارة موظفي النظافة والصيانة</p>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-6">
            <h3 className="text-xl font-bold text-blue-800 mb-4">🧹 فريق النظافة</h3>
            <div className="space-y-3">
              {['سالم أحمد - نظافة الملاعب', 'فاطمة محمد - نظافة المكاتب', 'علي الزهراني - نظافة عامة'].map((cleaner, index) => (
                <div key={index} className="bg-white rounded-lg p-3 flex items-center justify-between">
                  <span className="text-gray-700">{cleaner}</span>
                  <span className="text-green-600 text-sm">✅ نشط</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-orange-50 to-orange-100 rounded-xl p-6">
            <h3 className="text-xl font-bold text-orange-800 mb-4">🔧 فريق الصيانة</h3>
            <div className="space-y-3">
              {['محمد السعد - صيانة كهربائية', 'خالد العمر - صيانة سباكة', 'أحمد الفهد - صيانة عامة'].map((maintenance, index) => (
                <div key={index} className="bg-white rounded-lg p-3 flex items-center justify-between">
                  <span className="text-gray-700">{maintenance}</span>
                  <span className="text-green-600 text-sm">✅ متاح</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const AttendanceComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">⏰</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">الحضور والانصراف</h1>
              <p className="text-gray-600">نظام متابعة حضور وانصراف الموظفين</p>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-xl p-6 text-white text-center">
            <div className="text-3xl font-bold">87</div>
            <div className="text-sm opacity-90">حاضر اليوم</div>
          </div>
          <div className="bg-gradient-to-r from-red-500 to-red-600 rounded-xl p-6 text-white text-center">
            <div className="text-3xl font-bold">5</div>
            <div className="text-sm opacity-90">غائب اليوم</div>
          </div>
          <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-xl p-6 text-white text-center">
            <div className="text-3xl font-bold">3</div>
            <div className="text-sm opacity-90">متأخر</div>
          </div>
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl p-6 text-white text-center">
            <div className="text-3xl font-bold">94%</div>
            <div className="text-sm opacity-90">معدل الحضور</div>
          </div>
        </div>

        <div className="bg-gray-50 rounded-xl p-6">
          <h3 className="text-xl font-bold text-gray-800 mb-4">سجل الحضور اليوم</h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="text-gray-600 text-sm">
                  <th className="text-right py-2">الموظف</th>
                  <th className="text-center py-2">وقت الوصول</th>
                  <th className="text-center py-2">وقت المغادرة</th>
                  <th className="text-center py-2">الحالة</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { name: 'أحمد محمد', arrival: '08:15', departure: '-', status: 'حاضر' },
                  { name: 'فاطمة سالم', arrival: '08:30', departure: '-', status: 'حاضر' },
                  { name: 'محمد العلي', arrival: '09:15', departure: '-', status: 'متأخر' },
                  { name: 'سعد الفهد', arrival: '-', departure: '-', status: 'غائب' }
                ].map((record, index) => (
                  <tr key={index} className="border-t">
                    <td className="py-3 font-medium">{record.name}</td>
                    <td className="py-3 text-center">{record.arrival}</td>
                    <td className="py-3 text-center">{record.departure}</td>
                    <td className="py-3 text-center">
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        record.status === 'حاضر' ? 'bg-green-100 text-green-600' :
                        record.status === 'متأخر' ? 'bg-yellow-100 text-yellow-600' :
                        'bg-red-100 text-red-600'
                      }`}>
                        {record.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const PerformanceReviewComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-purple-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">📊</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">تقييم الأداء</h1>
              <p className="text-gray-600">تقييم أداء الموظفين والمكافآت</p>
            </div>
          </div>
          <button className="bg-gradient-to-r from-purple-500 to-purple-600 text-white px-6 py-3 rounded-lg hover:shadow-lg transition-all">
            ➕ تقييم جديد
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { name: 'أحمد محمد', position: 'مدير إداري', score: 4.8, status: 'ممتاز', lastReview: '2024-08-15' },
            { name: 'فاطمة سالم', position: 'محاسبة', score: 4.5, status: 'جيد جداً', lastReview: '2024-08-20' },
            { name: 'محمد العلي', position: 'مدرب', score: 4.9, status: 'ممتاز', lastReview: '2024-08-10' }
          ].map((employee, index) => (
            <div key={index} className="bg-gradient-to-br from-purple-50 to-white rounded-xl p-6 border border-purple-200/50 hover:shadow-lg transition-all">
              <div className="flex items-center space-x-3 space-x-reverse mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white font-bold">
                  {employee.name.charAt(0)}
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">{employee.name}</h3>
                  <p className="text-sm text-purple-600">{employee.position}</p>
                </div>
              </div>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">التقييم الإجمالي</span>
                  <div className="flex items-center space-x-1">
                    <span className="font-bold text-purple-600">{employee.score}</span>
                    <span className="text-yellow-500">⭐</span>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">الحالة</span>
                  <span className={`px-2 py-1 rounded-full text-xs ${
                    employee.status === 'ممتاز' ? 'bg-green-100 text-green-600' : 'bg-blue-100 text-blue-600'
                  }`}>
                    {employee.status}
                  </span>
                </div>
                <div className="text-sm text-gray-500">
                  آخر تقييم: {employee.lastReview}
                </div>
              </div>
              <button className="w-full mt-4 bg-purple-50 text-purple-600 py-2 rounded-lg text-sm hover:bg-purple-100 transition-colors">
                عرض التفاصيل
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

// Additional Financial Components
const RevenuesComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">💵</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">الإيرادات</h1>
              <p className="text-gray-600">تتبع وإدارة جميع الإيرادات</p>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">إيرادات اليوم</h3>
            <p className="text-2xl font-bold">25,440 ر.س</p>
          </div>
          <div className="bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">هذا الأسبوع</h3>
            <p className="text-2xl font-bold">156,780 ر.س</p>
          </div>
          <div className="bg-gradient-to-r from-teal-500 to-teal-600 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">هذا الشهر</h3>
            <p className="text-2xl font-bold">642,350 ر.س</p>
          </div>
          <div className="bg-gradient-to-r from-cyan-500 to-cyan-600 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">هذا العام</h3>
            <p className="text-2xl font-bold">5,847,920 ر.س</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-gray-50 rounded-xl p-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4">مصادر الإيرادات</h3>
            <div className="space-y-3">
              {[
                { source: 'رسوم العضوية', amount: '45,000 ر.س', percentage: '35%' },
                { source: 'رعايات وإعلانات', amount: '32,000 ر.س', percentage: '25%' },
                { source: 'تذاكر المباريات', amount: '28,000 ر.س', percentage: '22%' },
                { source: 'بيع المنتجات', amount: '15,000 ر.س', percentage: '12%' },
                { source: 'أخرى', amount: '8,000 ر.س', percentage: '6%' }
              ].map((revenue, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-white rounded-lg">
                  <div>
                    <h4 className="font-semibold text-gray-800">{revenue.source}</h4>
                    <p className="text-sm text-gray-600">{revenue.percentage} من إجمالي الإيرادات</p>
                  </div>
                  <div className="text-green-600 font-bold">{revenue.amount}</div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="bg-gray-50 rounded-xl p-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4">آخر المعاملات</h3>
            <div className="space-y-3">
              {[
                { description: 'عضوية جديدة - أحمد محمد', amount: '+2,500 ر.س', date: '2024-09-14', type: 'عضوية' },
                { description: 'راعي رسمي - شركة الاتصالات', amount: '+15,000 ر.س', date: '2024-09-13', type: 'رعاية' },
                { description: 'تذاكر مباراة الأحد', amount: '+8,750 ر.س', date: '2024-09-12', type: 'تذاكر' }
              ].map((transaction, index) => (
                <div key={index} className="bg-white rounded-lg p-4 flex items-center justify-between">
                  <div>
                    <h4 className="font-semibold text-gray-800">{transaction.description}</h4>
                    <p className="text-sm text-gray-600">{transaction.type} • {transaction.date}</p>
                  </div>
                  <div className="text-green-600 font-bold">{transaction.amount}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const PayrollComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">💳</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">رواتب الموظفين</h1>
              <p className="text-gray-600">إدارة رواتب ومكافآت الموظفين</p>
            </div>
          </div>
          <button className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-3 rounded-lg hover:shadow-lg transition-all">
            💰 معالجة الرواتب
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">إجمالي الرواتب</h3>
            <p className="text-2xl font-bold">245,600 ر.س</p>
            <p className="text-blue-200 text-xs mt-1">هذا الشهر</p>
          </div>
          <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">المدفوع</h3>
            <p className="text-2xl font-bold">198,400 ر.س</p>
            <p className="text-green-200 text-xs mt-1">80.8%</p>
          </div>
          <div className="bg-gradient-to-r from-amber-600 to-amber-700 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">المعلق</h3>
            <p className="text-2xl font-bold">47,200 ر.س</p>
            <p className="text-amber-200 text-xs mt-1">19.2%</p>
          </div>
          <div className="bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl p-6 text-white">
            <h3 className="text-sm font-semibold mb-2">المكافآت</h3>
            <p className="text-2xl font-bold">15,800 ر.س</p>
            <p className="text-purple-200 text-xs mt-1">هذا الشهر</p>
          </div>
        </div>

        <div className="bg-gray-50 rounded-xl p-6">
          <h3 className="text-xl font-bold text-gray-800 mb-4">كشف الرواتب - سبتمبر 2024</h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="text-gray-600 text-sm border-b">
                  <th className="text-right py-3">الموظف</th>
                  <th className="text-center py-3">المنصب</th>
                  <th className="text-center py-3">الراتب الأساسي</th>
                  <th className="text-center py-3">البدلات</th>
                  <th className="text-center py-3">الخصومات</th>
                  <th className="text-center py-3">الصافي</th>
                  <th className="text-center py-3">الحالة</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { name: 'أحمد محمد', position: 'مدير إداري', basic: '15,000', allowances: '2,000', deductions: '500', net: '16,500', status: 'مدفوع' },
                  { name: 'فاطمة سالم', position: 'محاسبة', basic: '12,000', allowances: '1,500', deductions: '300', net: '13,200', status: 'مدفوع' },
                  { name: 'محمد العلي', position: 'مدرب', basic: '18,000', allowances: '3,000', deductions: '600', net: '20,400', status: 'معلق' }
                ].map((payroll, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50">
                    <td className="py-3 font-medium">{payroll.name}</td>
                    <td className="py-3 text-center text-gray-600">{payroll.position}</td>
                    <td className="py-3 text-center">{payroll.basic} ر.س</td>
                    <td className="py-3 text-center text-green-600">{payroll.allowances} ر.س</td>
                    <td className="py-3 text-center text-red-600">{payroll.deductions} ر.س</td>
                    <td className="py-3 text-center font-bold">{payroll.net} ر.س</td>
                    <td className="py-3 text-center">
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        payroll.status === 'مدفوع' ? 'bg-green-100 text-green-600' : 'bg-yellow-100 text-yellow-600'
                      }`}>
                        {payroll.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const BudgetComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">📈</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">الميزانية</h1>
              <p className="text-gray-600">التخطيط المالي وإدارة الميزانية</p>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-6">
            <h3 className="text-xl font-bold text-gray-800">الميزانية السنوية 2024</h3>
            {[
              { category: 'الرواتب والأجور', budgeted: '2,400,000', spent: '1,800,000', percentage: 75 },
              { category: 'المرافق والخدمات', budgeted: '480,000', spent: '320,000', percentage: 67 },
              { category: 'المعدات الرياضية', budgeted: '360,000', spent: '180,000', percentage: 50 },
              { category: 'التسويق والإعلان', budgeted: '240,000', spent: '160,000', percentage: 67 }
            ].map((item, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6">
                <div className="flex justify-between items-center mb-3">
                  <h4 className="font-semibold text-gray-800">{item.category}</h4>
                  <span className="text-sm text-gray-600">{item.percentage}%</span>
                </div>
                <div className="flex justify-between text-sm text-gray-600 mb-2">
                  <span>المُنفق: {item.spent} ر.س</span>
                  <span>المخطط: {item.budgeted} ر.س</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div 
                    className={`h-2 rounded-full ${item.percentage > 80 ? 'bg-red-500' : item.percentage > 60 ? 'bg-yellow-500' : 'bg-green-500'}`}
                    style={{ width: `${item.percentage}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl p-6">
            <h3 className="text-xl font-bold text-gray-800 mb-6">ملخص الميزانية</h3>
            <div className="space-y-4">
              <div className="flex justify-between items-center p-4 bg-white rounded-lg">
                <span className="text-gray-600">إجمالي الميزانية</span>
                <span className="font-bold text-indigo-600">3,480,000 ر.س</span>
              </div>
              <div className="flex justify-between items-center p-4 bg-white rounded-lg">
                <span className="text-gray-600">المُنفق حتى الآن</span>
                <span className="font-bold text-orange-600">2,460,000 ر.س</span>
              </div>
              <div className="flex justify-between items-center p-4 bg-white rounded-lg">
                <span className="text-gray-600">المتبقي</span>
                <span className="font-bold text-green-600">1,020,000 ر.س</span>
              </div>
              <div className="flex justify-between items-center p-4 bg-white rounded-lg">
                <span className="text-gray-600">نسبة الإنفاق</span>
                <span className="font-bold text-purple-600">70.7%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const FinancialReportsComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-teal-500 to-teal-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">📋</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">التقارير المالية</h1>
              <p className="text-gray-600">التقارير المالية التفصيلية</p>
            </div>
          </div>
          <button className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-6 py-3 rounded-lg hover:shadow-lg transition-all">
            📊 إنشاء تقرير جديد
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { title: 'قائمة الدخل', period: 'سبتمبر 2024', status: 'جاهز', type: 'شهري' },
            { title: 'الميزانية العمومية', period: 'Q3 2024', status: 'قيد المراجعة', type: 'ربع سنوي' },
            { title: 'التدفق النقدي', period: 'أغسطس 2024', status: 'جاهز', type: 'شهري' },
            { title: 'تقرير المصروفات', period: 'سبتمبر 2024', status: 'جاهز', type: 'شهري' },
            { title: 'تقرير الإيرادات', period: '2024', status: 'قيد التحضير', type: 'سنوي' },
            { title: 'تحليل الربحية', period: 'Q3 2024', status: 'جاهز', type: 'ربع سنوي' }
          ].map((report, index) => (
            <div key={index} className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 border border-teal-200/50 hover:shadow-lg transition-all">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-bold text-gray-800">{report.title}</h3>
                <span className={`px-2 py-1 rounded-full text-xs ${
                  report.status === 'جاهز' ? 'bg-green-100 text-green-600' :
                  report.status === 'قيد المراجعة' ? 'bg-yellow-100 text-yellow-600' :
                  'bg-blue-100 text-blue-600'
                }`}>
                  {report.status}
                </span>
              </div>
              <div className="space-y-2 text-sm text-gray-600 mb-4">
                <p>📅 الفترة: {report.period}</p>
                <p>📊 النوع: {report.type}</p>
              </div>
              <div className="flex space-x-2 space-x-reverse">
                <button className="flex-1 bg-teal-50 text-teal-600 py-2 rounded-lg text-sm hover:bg-teal-100 transition-colors">
                  عرض
                </button>
                <button className="flex-1 bg-blue-50 text-blue-600 py-2 rounded-lg text-sm hover:bg-blue-100 transition-colors">
                  تحميل PDF
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const InvoicesComponent = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 p-8" dir="rtl">
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200/50 p-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-12 h-12 bg-gradient-to-r from-cyan-500 to-cyan-600 rounded-xl flex items-center justify-center">
              <span className="text-2xl text-white">🧾</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">الفواتير</h1>
              <p className="text-gray-600">إدارة الفواتير والمدفوعات</p>
            </div>
          </div>
          <button className="bg-gradient-to-r from-cyan-500 to-cyan-600 text-white px-6 py-3 rounded-lg hover:shadow-lg transition-all">
            ➕ فاتورة جديدة
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-xl p-6 text-white text-center">
            <div className="text-2xl font-bold">47</div>
            <div className="text-sm opacity-90">فاتورة مدفوعة</div>
          </div>
          <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-xl p-6 text-white text-center">
            <div className="text-2xl font-bold">12</div>
            <div className="text-sm opacity-90">معلقة</div>
          </div>
          <div className="bg-gradient-to-r from-red-500 to-red-600 rounded-xl p-6 text-white text-center">
            <div className="text-2xl font-bold">3</div>
            <div className="text-sm opacity-90">متأخرة</div>
          </div>
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl p-6 text-white text-center">
            <div className="text-2xl font-bold">125,400</div>
            <div className="text-sm opacity-90">إجمالي (ر.س)</div>
          </div>
        </div>

        <div className="bg-gray-50 rounded-xl p-6">
          <h3 className="text-xl font-bold text-gray-800 mb-4">آخر الفواتير</h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="text-gray-600 text-sm border-b">
                  <th className="text-right py-3">رقم الفاتورة</th>
                  <th className="text-center py-3">العميل</th>
                  <th className="text-center py-3">المبلغ</th>
                  <th className="text-center py-3">تاريخ الإصدار</th>
                  <th className="text-center py-3">تاريخ الاستحقاق</th>
                  <th className="text-center py-3">الحالة</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { number: 'INV-001', client: 'شركة الاتصالات', amount: '15,000', issued: '2024-09-01', due: '2024-09-30', status: 'مدفوعة' },
                  { number: 'INV-002', client: 'البنك الأهلي', amount: '8,500', issued: '2024-09-05', due: '2024-10-05', status: 'معلقة' },
                  { number: 'INV-003', client: 'شركة الكهرباء', amount: '3,200', issued: '2024-08-28', due: '2024-09-15', status: 'متأخرة' }
                ].map((invoice, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50">
                    <td className="py-3 font-medium text-blue-600">{invoice.number}</td>
                    <td className="py-3 text-center">{invoice.client}</td>
                    <td className="py-3 text-center font-bold">{invoice.amount} ر.س</td>
                    <td className="py-3 text-center text-gray-600">{invoice.issued}</td>
                    <td className="py-3 text-center text-gray-600">{invoice.due}</td>
                    <td className="py-3 text-center">
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        invoice.status === 'مدفوعة' ? 'bg-green-100 text-green-600' :
                        invoice.status === 'معلقة' ? 'bg-yellow-100 text-yellow-600' :
                        'bg-red-100 text-red-600'
                      }`}>
                        {invoice.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const getTimeAgo = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  // استخدام التوقيت السعودي
  const saudiNow = new Date(now.toLocaleString("en-US", {timeZone: "Asia/Riyadh"}));
  const saudiDate = new Date(date.toLocaleString("en-US", {timeZone: "Asia/Riyadh"}));
  const diffInMinutes = Math.floor((saudiNow - saudiDate) / (1000 * 60));
  
  if (diffInMinutes < 1) return 'الآن';
  if (diffInMinutes < 60) return `منذ ${diffInMinutes} دقيقة`;
  
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `منذ ${diffInHours} ساعة`;
  
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) return `منذ ${diffInDays} يوم`;
  
  return date.toLocaleDateString('ar-SA');
};

// Advanced Twitter Box Component with Real API Integration
const AdvancedTwitterBox = ({ settings = {} }) => {
  const {
    username = 'alamjad_club',
    displayName = 'نادي الأمجاد السعودي',
    tweetsCount = 3,
    autoSlide = true,
    autoSlideSpeed = 5
  } = settings;

  const [currentTweetIndex, setCurrentTweetIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [tweets, setTweets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  // Fetch real tweets from backend API
  const fetchRealTweets = async () => {
    try {
      setLoading(true);
      console.log(`🔍 جلب التغريدات الحقيقية للمستخدم: @${username}`);
      
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/public/twitter/user/${username}/tweets?count=${tweetsCount}`);
      
      if (response.ok) {
        const realTweets = await response.json();
        console.log(`✅ تم جلب ${realTweets.length} تغريدة`, realTweets);
        
        // Process tweets for display
        const processedTweets = realTweets.map(tweet => ({
          id: tweet.id,
          text: tweet.text,
          author: displayName,
          username: username,
          verified: tweet.verified || true,
          date: new Date(tweet.created_at).toLocaleDateString('ar', { 
            month: 'short', 
            day: 'numeric' 
          }),
          time: new Date(tweet.created_at).toLocaleTimeString('ar', { 
            hour: '2-digit', 
            minute: '2-digit' 
          }),
          retweets: tweet.retweets || 0,
          likes: tweet.likes || 0,
          replies: tweet.replies || 0,
          views: formatViews(tweet.views),
          image: tweet.image,
          hashtags: tweet.hashtags || [],
          type: 'original',
          isReal: tweet.isReal !== false // Consider it real unless explicitly marked as false
        }));
        
        setTweets(processedTweets);
        setLastUpdate(new Date());
        
        if (realTweets.length > 0 && !realTweets[0].isReal) {
          console.log('⚠️ استخدام بيانات تجريبية - لا يوجد مفتاح Twitter API');
        }
        
      } else {
        console.error('❌ فشل في جلب التغريدات:', response.status);
        setTweets(getFallbackTweets());
      }
      
    } catch (error) {
      console.error('❌ خطأ في جلب التغريدات:', error);
      setTweets(getFallbackTweets());
    } finally {
      setLoading(false);
    }
  };

  // Fallback tweets if API fails
  const getFallbackTweets = () => ([
    {
      id: 'fallback_1',
      text: '🏆 نادي الأمجاد يواصل مسيرته نحو التميز\n\nفخورون بإنجازات فرقنا في جميع الفئات السنية ⚽\n\n#الأمجاد #التميز',
      author: displayName,
      username: username,
      verified: true,
      date: 'اليوم',
      time: '14:30',
      retweets: 45,
      likes: 189,
      replies: 12,
      views: '2.8K',
      image: null,
      hashtags: ['الأمجاد', 'التميز'],
      type: 'original',
      isReal: false
    }
  ]);

  // Format view counts
  const formatViews = (views) => {
    if (typeof views === 'string') return views;
    if (views > 1000) return `${(views / 1000).toFixed(1)}K`;
    return views?.toString() || '0';
  };

  // Initial load and auto refresh
  useEffect(() => {
    fetchRealTweets();
    
    // Auto refresh every 10 minutes
    const refreshInterval = setInterval(fetchRealTweets, 10 * 60 * 1000);
    
    return () => clearInterval(refreshInterval);
  }, [username, tweetsCount]);

  // Auto slide effect
  useEffect(() => {
    if (!autoSlide || tweets.length <= 1) return;

    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentTweetIndex(prev => (prev + 1) % tweets.length);
        setIsAnimating(false);
      }, 300);
    }, autoSlideSpeed * 1000);

    return () => clearInterval(interval);
  }, [autoSlide, autoSlideSpeed, tweets.length]);

  const handleTweetNavigation = (index) => {
    if (index === currentTweetIndex) return;
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentTweetIndex(index);
      setIsAnimating(false);
    }, 300);
  };

  const formatText = (text, hashtags = []) => {
    let formattedText = text;
    hashtags.forEach(hashtag => {
      formattedText = formattedText.replace(
        `#${hashtag}`, 
        `<span class="text-blue-500 font-medium">#${hashtag}</span>`
      );
    });
    return formattedText;
  };

  if (loading || tweets.length === 0) {
    return (
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6">
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
            <div className="animate-spin w-8 h-8 border-3 border-white border-t-transparent rounded-full"></div>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">جاري تحميل التغريدات...</h3>
          <p className="text-gray-600">يتم جلب آخر التحديثات من @{username}</p>
        </div>
      </div>
    );
  }

  const currentTweet = tweets[currentTweetIndex];

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6">
      <div className="text-center mb-6">
        <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
          <span className="text-white text-2xl font-bold">𝕏</span>
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          تابعنا على منصة X
        </h3>
        <p className="text-gray-600">
          آخر التحديثات من حساب @{username}
        </p>
      </div>

      {/* Tweet Container */}
      <div className="bg-white rounded-xl shadow-lg border hover:shadow-xl transition-all duration-300">
        {/* Tweet Header */}
        <div className="flex items-start p-4 pb-2">
          <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
            {/* Club Name Initial */}
            <span className="text-gray-700 text-lg font-bold">أ</span>
          </div>
          
          <div className="flex-1 min-w-0">
            <div className="flex items-center space-x-1 space-x-reverse">
              <h4 className="font-bold text-gray-900 truncate">{currentTweet.author}</h4>
              {currentTweet.verified && (
                <div className="w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-xs">✓</span>
                </div>
              )}
              <span className="text-gray-500 text-sm">@{currentTweet.username}</span>
              <span className="text-gray-400 text-sm">·</span>
              <span className="text-gray-500 text-sm">{currentTweet.date}</span>
            </div>
          </div>

          <div className="text-gray-400 hover:bg-gray-100 p-1 rounded-full cursor-pointer">
            <span>•••</span>
          </div>
        </div>

        {/* Tweet Content */}
        <div className={`px-4 pb-3 transition-all duration-300 ${isAnimating ? 'opacity-50 transform translate-y-2' : 'opacity-100 transform translate-y-0'}`}>
          <div 
            className="text-gray-800 text-base leading-relaxed mb-3"
            dangerouslySetInnerHTML={{ 
              __html: formatText(currentTweet.text, currentTweet.hashtags) 
            }}
          />

          {/* Real Tweet Image (if exists) */}
          {currentTweet.image && (
            <div className="rounded-2xl overflow-hidden mb-3 border border-gray-200">
              <img 
                src={currentTweet.image}
                alt="صورة التغريدة الحقيقية"
                className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                crossOrigin="anonymous"
                onError={(e) => {
                  console.log('خطأ في تحميل الصورة:', e.target.src);
                  // Fallback to placeholder if real image fails
                  e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDUwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI1MDAiIGhlaWdodD0iMzAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0yMTAgMTUwSDE5MFYxNzBIMjEwVjE1MFoiIGZpbGw9IiM5Q0E0QUYiLz4KPHA+2KfZhNi12YjYsdipINi62YrYsSDZhdiq2KfYrdipPC9wPgo8L3N2Zz4K';
                }}
                onLoad={() => {
                  console.log('✅ تم تحميل الصورة الحقيقية بنجاح');
                }}
              />
            </div>
          )}

          {/* Tweet Stats */}
          <div className="flex items-center justify-between text-gray-500 text-sm pt-3 border-t border-gray-100">
            <div className="flex items-center space-x-6 space-x-reverse">
              <div className="flex items-center space-x-1 space-x-reverse hover:text-blue-600 cursor-pointer">
                <span>💬</span>
                <span>{currentTweet.replies}</span>
              </div>
              
              <div className="flex items-center space-x-1 space-x-reverse hover:text-green-600 cursor-pointer">
                <span>🔄</span>
                <span>{currentTweet.retweets}</span>
              </div>
              
              <div className="flex items-center space-x-1 space-x-reverse hover:text-red-600 cursor-pointer">
                <span>🤍</span>
                <span>{currentTweet.likes}</span>
              </div>

              <div className="flex items-center space-x-1 space-x-reverse hover:text-blue-600 cursor-pointer">
                <span>👁️</span>
                <span>{currentTweet.views}</span>
              </div>
            </div>

            <div className="hover:text-blue-600 cursor-pointer">
              <span>📤</span>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Dots */}
      {tweets.length > 1 && (
        <div className="flex justify-center mt-4 space-x-2 space-x-reverse">
          {tweets.map((_, index) => (
            <button
              key={index}
              onClick={() => handleTweetNavigation(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                currentTweetIndex === index 
                  ? 'bg-blue-600 w-8' 
                  : 'bg-gray-300 hover:bg-gray-400'
              }`}
            />
          ))}
        </div>
      )}

      {/* Follow Button */}
      <div className="text-center mt-6">
        <a
          href={`https://x.com/${username}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-8 py-3 bg-black hover:bg-gray-800 text-white font-bold rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg"
        >
          <span className="mr-2">𝕏</span>
          متابعة @{username}
        </a>
      </div>

      {/* Tweet Count and Last Update Indicator */}
      <div className="text-center mt-4 space-y-2">
        <span className="text-xs text-gray-500">
          {currentTweetIndex + 1} من {tweets.length} تغريدة
        </span>
        <div className="text-xs text-gray-400 flex items-center justify-center space-x-1 space-x-reverse">
          <span>🔄</span>
          <span>آخر تحديث: {new Date().toLocaleTimeString('ar', { hour: '2-digit', minute: '2-digit' })}</span>
        </div>
        <div className="text-xs text-blue-500">
          التحديث التلقائي كل 10 دقائق
        </div>
      </div>
    </div>
  );
};

// Combined News and Announcements Ticker Component 
// Combined News and Announcements Ticker Component 
const CombinedNewsTicker = ({ newsItems = [], announcements = [], settings = {} }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [tickerItems, setTickerItems] = useState([]);

  useEffect(() => {
    // Combine news and announcements with priority
    const combinedItems = [];
    
    // Add high priority announcements first
    const highPriorityAnnouncements = announcements
      .filter(ann => ann.show_on_ticker && ann.is_active && ann.priority === 'urgent')
      .map(ann => ({
        id: `ann-${ann.id}`,
        text: `🚨 ${ann.title}: ${ann.content}`,
        type: 'announcement',
        priority: 'urgent',
        category: ann.category
      }));
    
    // Add important announcements
    const importantAnnouncements = announcements
      .filter(ann => ann.show_on_ticker && ann.is_active && ann.priority === 'high')
      .map(ann => ({
        id: `ann-${ann.id}`,
        text: `⚠️ ${ann.title}: ${ann.content}`,
        type: 'announcement',
        priority: 'high',
        category: ann.category
      }));
    
    // Add normal announcements
    const normalAnnouncements = announcements
      .filter(ann => ann.show_on_ticker && ann.is_active && (ann.priority === 'normal' || ann.priority === 'low'))
      .map(ann => ({
        id: `ann-${ann.id}`,
        text: `📢 ${ann.title}: ${ann.content}`,
        type: 'announcement',
        priority: ann.priority,
        category: ann.category
      }));
    
    // Add news items
    const newsTickerItems = newsItems
      .slice(0, 5)
      .map(news => ({
        id: `news-${news.id}`,
        text: `📰 ${news.title}: ${news.summary || news.content?.substring(0, 100)}`,
        type: 'news',
        priority: 'normal',
        category: 'news'
      }));
    
    // Combine all items with priority order
    combinedItems.push(
      ...highPriorityAnnouncements,
      ...importantAnnouncements,
      ...normalAnnouncements,
      ...newsTickerItems
    );
    
    setTickerItems(combinedItems);
  }, [newsItems, announcements]);

  // Auto-rotate ticker items
  useEffect(() => {
    if (tickerItems.length <= 1) return;
    
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % tickerItems.length);
    }, settings.tickerSpeed || 5000);
    
    return () => clearInterval(interval);
  }, [tickerItems.length, settings.tickerSpeed]);

  if (tickerItems.length === 0) {
    return (
      <div 
        className="py-3 px-6 text-center text-sm font-medium"
        style={{
          backgroundColor: settings.backgroundColor || '#ea580c',
          color: settings.textColor || '#ffffff'
        }}
      >
        🏆 مرحباً بكم في الموقع الرسمي لنادي الأمجاد - تابعونا للحصول على آخر الأخبار والأحداث
      </div>
    );
  }

  const currentItem = tickerItems[currentIndex];

  return (
    <div 
      className="relative overflow-hidden"
      style={{
        backgroundColor: settings.backgroundColor || '#ea580c',
        color: settings.textColor || '#ffffff'
      }}
    >
      <div className="flex items-center px-6 py-3">
        {/* Ticker Icon */}
        <div className="flex-shrink-0 ml-4">
          <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
            <span className="text-lg">
              {currentItem?.type === 'announcement' ? '📢' : '📰'}
            </span>
          </div>
        </div>
        
        {/* Ticker Content */}
        <div className="flex-1 min-w-0">
          <div className="animate-ticker-slide">
            <span className="text-sm font-medium whitespace-nowrap">
              {currentItem?.text}
            </span>
          </div>
        </div>
        
        {/* Navigation Dots */}
        {tickerItems.length > 1 && (
          <div className="flex-shrink-0 flex items-center space-x-1 space-x-reverse mr-4">
            {tickerItems.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  currentIndex === index 
                    ? 'bg-white w-4' 
                    : 'bg-white/40 hover:bg-white/70'
                }`}
              />
            ))}
          </div>
        )}
        
        {/* Priority Indicator */}
        {currentItem?.priority === 'urgent' && (
          <div className="flex-shrink-0 ml-2">
            <span className="bg-red-500 text-white px-2 py-1 rounded-full text-xs font-bold animate-pulse">
              عاجل
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

// Twitter Feed Component for displaying last 5 tweets with preview
const TwitterFeed = ({ username }) => {
  const [tweets, setTweets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTweets();
  }, [username]);

  const fetchTweets = async () => {
    if (!username) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/x-tweets/${username}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      setTweets(response.data.slice(0, 5)); // Only show last 5 tweets
    } catch (error) {
      console.error('خطأ في جلب التغريدات:', error);
      setError('فشل في جلب التغريدات');
      
      // Enhanced fallback with more realistic mock tweets
      setTweets([
        {
          id: '1',
          text: `🔴 أهلاً وسهلاً بكم في الحساب الرسمي لـ @${username} - نشارككم آخر أخبار النادي والفعاليات القادمة`,
          created_at: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
          author: username,
          link: `https://x.com/${username}`
        },
        {
          id: '2', 
          text: `⚽ متابعة مميزة لأحداث النادي وأخبار اللاعبين من @${username} - ترقبوا المفاجآت القادمة!`,
          created_at: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(),
          author: username,
          link: `https://x.com/${username}`
        },
        {
          id: '3',
          text: `🏆 نشكر جميع الجماهير على دعمهم المستمر للنادي. معاً نحو المزيد من الإنجازات!`,
          created_at: new Date(Date.now() - 1000 * 60 * 60 * 4).toISOString(),
          author: username,
          link: `https://x.com/${username}`
        },
        {
          id: '4',
          text: `📅 لا تفوتوا المباراة القادمة يوم الجمعة في ملعب النادي. تذاكر محدودة متاحة الآن!`,
          created_at: new Date(Date.now() - 1000 * 60 * 60 * 8).toISOString(),
          author: username,
          link: `https://x.com/${username}`
        },
        {
          id: '5',
          text: `💪 تدريبات مكثفة للفريق استعداداً للمباراة المصيرية. الجميع في قمة الجاهزية!`,
          created_at: new Date(Date.now() - 1000 * 60 * 60 * 12).toISOString(),
          author: username,
          link: `https://x.com/${username}`
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="space-y-3">
        <div className="flex items-center justify-between mb-3">
          <h6 className="text-sm font-semibold text-gray-600">آخر 5 تغريدات:</h6>
          <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        </div>
        {[1, 2, 3].map(i => (
          <div key={i} className="animate-pulse bg-gray-50 rounded-lg p-3">
            <div className="flex items-center space-x-2 space-x-reverse mb-2">
              <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
              <div className="h-3 bg-gray-200 rounded w-20"></div>
            </div>
            <div className="h-4 bg-gray-200 rounded w-full mb-1"></div>
            <div className="h-3 bg-gray-200 rounded w-3/4"></div>
          </div>
        ))}
      </div>
    );
  }

  if (error && tweets.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-red-500 text-sm">{error}</p>
        <button
          onClick={fetchTweets}
          className="mt-2 text-blue-500 text-xs hover:underline"
        >
          🔄 إعادة المحاولة
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between mb-3">
        <h6 className="text-sm font-semibold text-gray-600 flex items-center">
          <span className="ml-1">𝕏</span>
          آخر {tweets.length} تغريدات:
        </h6>
        <button
          onClick={fetchTweets}
          className="text-blue-500 hover:text-blue-600 text-xs"
          disabled={loading}
        >
          🔄 تحديث
        </button>
      </div>
      
      <div className="max-h-80 overflow-y-auto space-y-2">
        {tweets.length === 0 ? (
          <div className="text-center py-4 text-gray-500">
            <span className="text-2xl mb-2 block">😔</span>
            <p className="text-sm">لا توجد تغريدات حديثة</p>
          </div>
        ) : (
          tweets.map((tweet, index) => (
            <div key={tweet.id || index} className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-3 border-l-3 border-blue-400 hover:shadow-sm transition-shadow">
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center space-x-2 space-x-reverse">
                  <span className="text-blue-600 font-bold">𝕏</span>
                  <span className="text-xs font-semibold text-gray-700">@{tweet.author}</span>
                </div>
                <span className="text-xs text-gray-400">
                  {formatSimpleDateTime(tweet.created_at)}
                </span>
              </div>
              
              <p className="text-sm text-gray-700 leading-relaxed mb-2 line-clamp-3">
                {tweet.text}
              </p>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2 space-x-reverse text-xs text-gray-500">
                  <span>💬 {Math.floor(Math.random() * 20) + 1}</span>
                  <span>🔄 {Math.floor(Math.random() * 15) + 1}</span>
                  <span>❤️ {Math.floor(Math.random() * 50) + 5}</span>
                </div>
                
                {tweet.link && (
                  <a
                    href={tweet.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:text-blue-600 text-xs font-medium hover:underline"
                  >
                    عرض التغريدة ↗
                  </a>
                )}
              </div>
            </div>
          ))
        )}
      </div>
      
      {tweets.length > 0 && (
        <div className="text-center pt-2">
          <a
            href={`https://x.com/${username}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:text-blue-600 text-sm font-medium hover:underline"
          >
            🔗 زيارة الحساب الكامل على X
          </a>
        </div>
      )}
    </div>
  );
};

// Twitter Box Section Component
const TwitterBoxSection = () => {
  const [twitterData, setTwitterData] = useState({
    tweets: [],
    settings: {
      show_twitter_box: true,
      follow_button_text: 'تابعنا على تويتر',
      twitter_username: 'alamjad_club',
      display_name: 'نادي الأمجاد',
      bio: 'النادي الرياضي الرائد في المنطقة',
      box_title: 'آخر التغريدات'
    }
  });
  
  const [clubLogo, setClubLogo] = useState(null);
  const [currentTweetIndex, setCurrentTweetIndex] = useState(0);

  useEffect(() => {
    fetchTwitterData();
    fetchClubLogo();
    
    // Auto-switch tweets every 5 seconds if multiple tweets
    const interval = setInterval(() => {
      setCurrentTweetIndex(prev => 
        twitterData.tweets.length > 1 ? (prev + 1) % twitterData.tweets.length : 0
      );
    }, 5000);
    
    return () => clearInterval(interval);
  }, [twitterData.tweets.length]);

  const fetchTwitterData = async () => {
    try {
      const [tweetsRes, settingsRes] = await Promise.allSettled([
        axios.get(`${API}/public/local-tweets?limit=3`),
        axios.get(`${API}/public/twitter-settings`)
      ]);

      const tweets = tweetsRes.status === 'fulfilled' ? tweetsRes.value.data : [];
      const settings = settingsRes.status === 'fulfilled' ? settingsRes.value.data : twitterData.settings;

      setTwitterData({ tweets, settings });
    } catch (error) {
      console.error('خطأ في جلب بيانات تويتر:', error);
    }
  };

  const fetchClubLogo = async () => {
    try {
      const response = await axios.get(`${API}/public/club-info`);
      if (response.data && response.data.logo_file_id) {
        setClubLogo(response.data.logo_file_id);
      }
    } catch (error) {
      console.error('خطأ في جلب شعار النادي:', error);
    }
  };

  // Don't render if disabled or no tweets
  if (!twitterData.settings.show_twitter_box || twitterData.tweets.length === 0) return null;

  const currentTweet = twitterData.tweets[currentTweetIndex];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-200">
          {/* Twitter-like Header */}
          <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-black text-white px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3 space-x-reverse">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-orange-500">
                  {clubLogo ? (
                    <img 
                      src={`${API}/files/${clubLogo}`}
                      alt={twitterData.settings.display_name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center">
                      <span className="text-white font-bold text-lg">أ</span>
                    </div>
                  )}
                </div>
                <div>
                  <h3 className="text-lg font-bold">{twitterData.settings.display_name}</h3>
                  <p className="text-gray-300 text-sm">@{twitterData.settings.twitter_username}</p>
                </div>
              </div>
              <div className="text-blue-400 text-xl">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </div>
            </div>
          </div>

          {/* Single Tweet Display */}
          <div className="p-6">
            <div className="flex items-start space-x-3 space-x-reverse">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                {clubLogo ? (
                  <img 
                    src={`${API}/files/${clubLogo}`}
                    alt={currentTweet?.author_name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center">
                    <span className="text-white font-bold text-sm">أ</span>
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2 space-x-reverse mb-2">
                  <span className="font-bold text-gray-900">{currentTweet?.author_name}</span>
                  <span className="w-4 h-4 text-blue-500">
                    <svg fill="currentColor" viewBox="0 0 24 24">
                      <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 3.95-.36.1-.74.15-1.13.15-.27 0-.54-.03-.8-.08.54 1.69 2.11 2.95 4 2.98-1.46 1.16-3.31 1.84-5.33 1.84-.35 0-.69-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
                    </svg>
                  </span>
                  <span className="text-gray-500 text-sm">@{currentTweet?.author_username}</span>
                  <span className="text-gray-400 text-sm">·</span>
                  <span className="text-gray-500 text-sm">
                    {new Date(currentTweet?.created_at).toLocaleDateString('ar-SA')}
                  </span>
                </div>
                
                <div className="text-gray-800 text-lg leading-relaxed mb-4">
                  {currentTweet?.content}
                </div>
                
                <div className="flex items-center justify-between text-gray-500 text-sm max-w-md">
                  <div className="flex items-center space-x-1 space-x-reverse hover:text-blue-500 cursor-pointer transition-colors group">
                    <div className="w-8 h-8 rounded-full group-hover:bg-blue-50 flex items-center justify-center">
                      <span>💬</span>
                    </div>
                    <span>{currentTweet?.replies || 0}</span>
                  </div>
                  <div className="flex items-center space-x-1 space-x-reverse hover:text-green-500 cursor-pointer transition-colors group">
                    <div className="w-8 h-8 rounded-full group-hover:bg-green-50 flex items-center justify-center">
                      <span>🔄</span>
                    </div>
                    <span>{currentTweet?.retweets || 0}</span>
                  </div>
                  <div className="flex items-center space-x-1 space-x-reverse hover:text-red-500 cursor-pointer transition-colors group">
                    <div className="w-8 h-8 rounded-full group-hover:bg-red-50 flex items-center justify-center">
                      <span>❤️</span>
                    </div>
                    <span>{currentTweet?.likes || 0}</span>
                  </div>
                  <div className="flex items-center space-x-1 space-x-reverse hover:text-blue-500 cursor-pointer transition-colors group">
                    <div className="w-8 h-8 rounded-full group-hover:bg-blue-50 flex items-center justify-center">
                      <span>📤</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tweet Navigation Dots (if multiple tweets) */}
          {twitterData.tweets.length > 1 && (
            <div className="flex justify-center space-x-2 space-x-reverse pb-4">
              {twitterData.tweets.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTweetIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === currentTweetIndex 
                      ? 'bg-orange-500 w-6' 
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>
          )}

          {/* Follow Button */}
          <div className="bg-gray-50 px-6 py-4">
            <a
              href={`https://twitter.com/${twitterData.settings.twitter_username}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-bold py-3 px-6 rounded-2xl transition-all duration-300 flex items-center justify-center space-x-2 space-x-reverse shadow-lg hover:shadow-xl group"
            >
              <svg className="w-5 h-5 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              <span>{twitterData.settings.follow_button_text}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

// Add Google Fonts for Arabic fonts
const ARABIC_FONTS_LINKS = [
  'https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700&display=swap',
  'https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700&display=swap',
  'https://fonts.googleapis.com/css2?family=Almarai:wght@400;700&display=swap',
  'https://fonts.googleapis.com/css2?family=Amiri:wght@400;700&display=swap',
  'https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@400;500;600;700&display=swap'
];

// Load Arabic fonts
const loadArabicFonts = () => {
  ARABIC_FONTS_LINKS.forEach(href => {
    if (!document.querySelector(`link[href="${href}"]`)) {
      const link = document.createElement('link');
      link.href = href;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
  });
};

// Initialize fonts on app start
loadArabicFonts();

// Format date utility function - Convert to Gregorian calendar
const formatDateGregorian = (dateString, includeTime = false) => {
  if (!dateString) return { date: 'غير محدد', time: '' };
  
  try {
    const date = new Date(dateString);
    const gregorianDate = date.toLocaleDateString('ar-SA-u-ca-gregory', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    
    const time = includeTime ? date.toLocaleTimeString('ar-SA', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }) : date.toLocaleTimeString('ar-SA', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    
    return { 
      date: gregorianDate, 
      time: time,
      fullDateTime: `${gregorianDate} - ${time}`
    };
  } catch (error) {
    console.error('Date formatting error:', error);
    return { date: 'غير صحيح', time: '' };
  }
};

// Simple date formatter for common use cases - Always Gregorian
const formatSimpleDate = (dateString) => {
  if (!dateString) return 'غير محدد';
  try {
    return new Date(dateString).toLocaleDateString('ar-SA-u-ca-gregory');
  } catch (error) {
    return 'غير صحيح';
  }
};

// Simple datetime formatter - Always Gregorian
const formatSimpleDateTime = (dateString) => {
  if (!dateString) return 'غير محدد';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('ar-SA-u-ca-gregory', {
      year: 'numeric',
      month: 'long', 
      day: 'numeric'
    });
  } catch (error) {
    return 'غير صحيح';
  }
};

// Enhanced Match Card Component - Professional and Simplified Design
const ProfessionalMatchCard = ({ match, onEditResult, onEditMatch, onManageGoals, onManageCards, onDeleteMatch, isFinished = false }) => {
  const { date, time } = formatDateGregorian(match.match_date, true);
  
  // Determine match result for Al-Amjad - only if scores are available and not zero
  const homeScore = match.home_score;
  const awayScore = match.away_score;
  const hasValidScores = homeScore !== null && homeScore !== undefined && awayScore !== null && awayScore !== undefined && (homeScore > 0 || awayScore > 0);
  const isAlAmjadHome = (match.home_team && typeof match.home_team === 'string' && (match.home_team.includes('الأمجاد') || match.home_team.includes('امجاد') || match.home_team === 'الأمجاد')) || 
                        (match.home_team_name && typeof match.home_team_name === 'string' && (match.home_team_name.includes('الأمجاد') || match.home_team_name.includes('امجاد') || match.home_team_name === 'الأمجاد'));
  const isAlAmjadAway = (match.away_team && typeof match.away_team === 'string' && (match.away_team.includes('الأمجاد') || match.away_team.includes('امجاد') || match.away_team === 'الأمجاد')) || 
                        (match.away_team_name && typeof match.away_team_name === 'string' && (match.away_team_name.includes('الأمجاد') || match.away_team_name.includes('امجاد') || match.away_team_name === 'الأمجاد'));
  
  let matchResult = 'draw'; // draw, win, loss
  if (isFinished && hasValidScores) {
    if ((isAlAmjadHome && homeScore > awayScore) || (isAlAmjadAway && awayScore > homeScore)) {
      matchResult = 'win';
    } else if (homeScore !== awayScore) {
      matchResult = 'loss';
    }
  }
  
  const resultStyles = {
    win: 'from-green-500 to-green-600 border-green-300',
    loss: 'from-red-500 to-red-600 border-red-300',
    draw: 'from-yellow-500 to-yellow-600 border-yellow-300',
    upcoming: 'from-blue-500 to-blue-600 border-blue-300'
  };
  
  const resultBadge = {
    win: { text: 'فوز', emoji: '🏆', color: 'bg-green-100 text-green-800' },
    loss: { text: 'هزيمة', emoji: '😔', color: 'bg-red-100 text-red-800' },
    draw: { text: 'تعادل', emoji: '🤝', color: 'bg-yellow-100 text-yellow-800' },
    upcoming: { text: 'قادمة', emoji: '⏰', color: 'bg-blue-100 text-blue-800' }
  };
  
  const currentResult = isFinished ? matchResult : 'upcoming';
  
  return (
    <div className={`bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border-2 ${resultStyles[currentResult].split(' ')[2]} transform hover:scale-105 relative`}>
      {/* Delete Button */}
      <button
        onClick={() => onDeleteMatch(match)}
        className="absolute top-2 left-2 w-8 h-8 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center transition-colors z-10 shadow-md"
        title="حذف المباراة"
      >
        <span className="text-sm font-bold">×</span>
      </button>

      {/* Header with gradient */}
      <div className={`bg-gradient-to-r ${resultStyles[currentResult].split(' ').slice(0, 2).join(' ')} text-white p-4`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 space-x-reverse">
            <span className="text-lg">{resultBadge[currentResult].emoji}</span>
            <div>
              <h3 className="font-bold text-sm">{match.tournament_name || 'دوري النادي'}</h3>
              <p className="text-xs opacity-90">{date}</p>
            </div>
          </div>
          <div className={`px-3 py-1 rounded-full text-xs font-bold ${resultBadge[currentResult].color} text-gray-800`}>
            {resultBadge[currentResult].text}
          </div>
        </div>
      </div>
      
      {/* Teams Section */}
      <div className="p-6">
        <div className="flex items-center justify-between">
          {/* Home Team */}
          <div className="text-center flex-1">
            <div className="w-14 h-14 mx-auto mb-3 bg-gradient-to-br from-orange-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
              <span className="text-white text-xl font-bold">🏠</span>
            </div>
            <h4 className="font-bold text-gray-800 text-sm mb-1 truncate">{match.home_team}</h4>
            <span className="text-xs text-gray-500">مضيف</span>
          </div>
          
          {/* Score or VS */}
          <div className="px-6 text-center">
            {isFinished && hasValidScores ? (
              <div className="bg-gray-50 rounded-lg p-4 border-2 border-gray-200">
                <div className="flex items-center space-x-4 space-x-reverse">
                  <span className="text-3xl font-bold text-gray-800">{homeScore}</span>
                  <span className="text-lg text-gray-400">-</span>
                  <span className="text-3xl font-bold text-gray-800">{awayScore}</span>
                </div>
              </div>
            ) : (
              <div className="text-center">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-2 border-2 border-gray-200">
                  <span className="font-bold text-gray-600 text-sm">VS</span>
                </div>
                <p className="text-sm font-bold text-gray-700">{time}</p>
              </div>
            )}
          </div>
          
          {/* Away Team */}
          <div className="text-center flex-1">
            <div className="w-14 h-14 mx-auto mb-3 bg-gradient-to-br from-gray-400 to-gray-500 rounded-full flex items-center justify-center shadow-lg">
              <span className="text-white text-xl font-bold">⚔️</span>
            </div>
            <h4 className="font-bold text-gray-800 text-sm mb-1 truncate">{match.away_team}</h4>
            <span className="text-xs text-gray-500">ضيف</span>
          </div>
        </div>
        
        {/* Venue */}
        {match.venue && (
          <div className="mt-4 text-center">
            <p className="text-xs text-gray-500 flex items-center justify-center">
              <span className="ml-1">📍</span>
              {match.venue}
            </p>
          </div>
        )}
        
        {/* Action Buttons - 4 Buttons Grid */}
        <div className="mt-6 grid grid-cols-2 gap-3">
          <button
            onClick={() => onEditMatch(match)}
            className="bg-gradient-to-r from-indigo-500 to-indigo-600 hover:from-indigo-600 hover:to-indigo-700 text-white py-3 px-3 rounded-lg font-bold text-xs transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
            title="تعديل بيانات المباراة"
          >
            <div className="text-center">
              <div className="text-base mb-1">✏️</div>
              <div className="font-bold">تعديل</div>
            </div>
          </button>
          
          <button
            onClick={() => onEditResult(match)}
            className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white py-3 px-3 rounded-lg font-bold text-xs transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
            title="إدخال/تعديل نتيجة المباراة"
          >
            <div className="text-center">
              <div className="text-base mb-1">⚽</div>
              <div className="font-bold">النتيجة</div>
            </div>
          </button>
          
          <button
            onClick={() => onManageGoals(match)}
            className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-3 px-3 rounded-lg font-bold text-xs transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
            title="إدارة الأهداف"
          >
            <div className="text-center">
              <div className="text-base mb-1">🥅</div>
              <div className="font-bold">أهداف</div>
            </div>
          </button>
          
          <button
            onClick={() => onManageCards(match)}
            className="bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-white py-3 px-3 rounded-lg font-bold text-xs transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
            title="إدارة الكروت"
          >
            <div className="text-center">
              <div className="text-base mb-1">🟨</div>
              <div className="font-bold">كروت</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

// Advanced Permissions System Constants
const PERMISSIONS = {
  // View Permissions
  VIEW_DASHBOARD: 'view_dashboard',
  VIEW_PLAYERS: 'view_players', 
  VIEW_TEAMS: 'view_teams',
  VIEW_MATCHES: 'view_matches',
  VIEW_TOURNAMENTS: 'view_tournaments',
  VIEW_NEWS: 'view_news',
  VIEW_STATISTICS: 'view_statistics',
  VIEW_USERS: 'view_users',
  VIEW_SETTINGS: 'view_settings',
  VIEW_ACTIVITY_LOG: 'view_activity_log',

  // Create Permissions
  CREATE_PLAYERS: 'create_players',
  CREATE_TEAMS: 'create_teams', 
  CREATE_MATCHES: 'create_matches',
  CREATE_TOURNAMENTS: 'create_tournaments',
  CREATE_NEWS: 'create_news',
  CREATE_USERS: 'create_users',

  // Edit Permissions
  EDIT_PLAYERS: 'edit_players',
  EDIT_TEAMS: 'edit_teams',
  EDIT_MATCHES: 'edit_matches', 
  EDIT_TOURNAMENTS: 'edit_tournaments',
  EDIT_NEWS: 'edit_news',
  EDIT_USERS: 'edit_users',
  EDIT_SETTINGS: 'edit_settings',

  // Delete Permissions
  DELETE_PLAYERS: 'delete_players',
  DELETE_TEAMS: 'delete_teams',
  DELETE_MATCHES: 'delete_matches',
  DELETE_TOURNAMENTS: 'delete_tournaments', 
  DELETE_NEWS: 'delete_news',
  DELETE_USERS: 'delete_users',

  // System Permissions
  MANAGE_PERMISSIONS: 'manage_permissions',
  EXPORT_DATA: 'export_data',
  IMPORT_DATA: 'import_data',
  BACKUP_SYSTEM: 'backup_system',
  SYSTEM_SETTINGS: 'system_settings'
};

const ROLE_TEMPLATES = {
  administrator: {
    name: 'مدير النظام',
    description: 'صلاحيات كاملة على جميع أقسام النظام',
    permissions: Object.values(PERMISSIONS),
    color: 'bg-red-500',
    icon: '👑'
  },
  supervisor: {
    name: 'مشرف عام', 
    description: 'إدارة البيانات والمحتوى مع صلاحيات محدودة',
    permissions: [
      PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.VIEW_PLAYERS, PERMISSIONS.VIEW_TEAMS,
      PERMISSIONS.VIEW_MATCHES, PERMISSIONS.VIEW_TOURNAMENTS, PERMISSIONS.VIEW_NEWS,
      PERMISSIONS.VIEW_STATISTICS, PERMISSIONS.CREATE_PLAYERS, PERMISSIONS.CREATE_TEAMS,
      PERMISSIONS.CREATE_MATCHES, PERMISSIONS.EDIT_PLAYERS, PERMISSIONS.EDIT_TEAMS,
      PERMISSIONS.EDIT_MATCHES, PERMISSIONS.DELETE_PLAYERS
    ],
    color: 'bg-blue-500',
    icon: '👨‍💼'
  },
  coach: {
    name: 'مدرب',
    description: 'إدارة اللاعبين والمباريات والتدريب',
    permissions: [
      PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.VIEW_PLAYERS, PERMISSIONS.VIEW_TEAMS,
      PERMISSIONS.VIEW_MATCHES, PERMISSIONS.VIEW_STATISTICS, PERMISSIONS.CREATE_PLAYERS,
      PERMISSIONS.EDIT_PLAYERS, PERMISSIONS.EDIT_MATCHES
    ],
    color: 'bg-green-500',
    icon: '🏃‍♂️'
  },
  analyst: {
    name: 'محلل',
    description: 'مشاهدة التقارير والإحصائيات فقط',
    permissions: [
      PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.VIEW_PLAYERS, PERMISSIONS.VIEW_TEAMS,
      PERMISSIONS.VIEW_MATCHES, PERMISSIONS.VIEW_TOURNAMENTS, PERMISSIONS.VIEW_STATISTICS
    ],
    color: 'bg-purple-500',
    icon: '📊'
  },
  reporter: {
    name: 'مراسل', 
    description: 'إدارة الأخبار والمحتوى الإعلامي',
    permissions: [
      PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.VIEW_NEWS, PERMISSIONS.CREATE_NEWS,
      PERMISSIONS.EDIT_NEWS, PERMISSIONS.DELETE_NEWS
    ],
    color: 'bg-yellow-500',
    icon: '📰'
  }
};

// SEO Component for Dynamic Meta Tags
const SEOHead = ({ clubSettings = {} }) => {
  useEffect(() => {
    // Update page title
    const pageTitle = clubSettings.page_title || clubSettings.app_name || `${clubSettings.club_name || 'النادي الرياضي'} - الموقع الرسمي`;
    document.title = pageTitle;
    
    // Update meta description
    const metaDescription = clubSettings.meta_description || clubSettings.description || `الموقع الرسمي للنادي الرياضي. تابع آخر أخبار النادي، المباريات واللاعبين.`;
    let descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', metaDescription);
    }
    
    // Update keywords
    if (clubSettings.keywords) {
      let keywordsMeta = document.querySelector('meta[name="keywords"]');
      if (keywordsMeta) {
        keywordsMeta.setAttribute('content', clubSettings.keywords);
      }
    }
    
    // Update Open Graph tags
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', pageTitle);
    }
    
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', metaDescription);
    }
    
    // Update Twitter tags
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', pageTitle);
    }
    
    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', metaDescription);
    }
    
    // Update favicon if favicon exists
    if (clubSettings.favicon_file_id) {
      const faviconLink = document.querySelector('link[rel="icon"]') || 
                          document.querySelector('link[rel="shortcut icon"]');
      if (faviconLink) {
        faviconLink.href = `${API}/files/${clubSettings.favicon_file_id}`;
      } else {
        // Create new favicon link if it doesn't exist
        const newFaviconLink = document.createElement('link');
        newFaviconLink.rel = 'icon';
        newFaviconLink.type = 'image/x-icon';
        newFaviconLink.href = `${API}/files/${clubSettings.favicon_file_id}`;
        document.head.appendChild(newFaviconLink);
      }
    } else if (clubSettings.logo_file_id) {
      // Use club logo as fallback favicon if no specific favicon is set
      const faviconLink = document.querySelector('link[rel="icon"]') || 
                          document.querySelector('link[rel="shortcut icon"]');
      if (faviconLink) {
        faviconLink.href = `${API}/files/${clubSettings.logo_file_id}`;
      } else {
        // Create new favicon link if it doesn't exist
        const newFaviconLink = document.createElement('link');
        newFaviconLink.rel = 'icon';
        newFaviconLink.type = 'image/x-icon';
        newFaviconLink.href = `${API}/files/${clubSettings.logo_file_id}`;
        document.head.appendChild(newFaviconLink);
      }
    }
    
  }, [clubSettings]);

  return null; // This component doesn't render anything
};

// Professional Landing Page Component (before login)
// Next Match Countdown Component
const NextMatchCountdown = ({ match, clubLogo, clubBasicInfo }) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isLive, setIsLive] = useState(false);

  const matchDateTime = match ? new Date(match.date || match.match_date) : null;
  const matchDayName = matchDateTime ? matchDateTime.toLocaleDateString('ar-SA', { weekday: 'long' }) : '';

  useEffect(() => {
    if (!match) return;

    const updateCountdown = () => {
      const matchDate = new Date(match.date || match.match_date);
      const now = new Date();
      const difference = matchDate.getTime() - now.getTime();

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [match]);

  if (!match) return null;

  const matchDate = new Date(match.date || match.match_date);
  const isValidDate = !isNaN(matchDate.getTime());
  const displayDate = isValidDate ? matchDate : new Date(Date.now() + (7 * 24 * 60 * 60 * 1000));

  return (
    <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl border border-gray-700/50 p-4 sm:p-6 shadow-2xl">
      {/* Teams Display with Time in Center */}
      <div className="flex items-center justify-center mb-6 space-x-4 sm:space-x-8 space-x-reverse">
        {/* Home Team (Al-Amjad) */}
        <div className="text-center">
          <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-2 relative">
            {clubLogo ? (
              <img 
                src={`${API}/files/${clubLogo}`}
                alt="شعار النادي"
                className="w-full h-full object-contain rounded-full border-2 border-orange-500 shadow-lg"
              />
            ) : (
              <div className="w-full h-full rounded-full border-2 border-orange-500 bg-orange-600 flex items-center justify-center shadow-lg">
                <span className="text-white text-lg sm:text-xl font-bold">أ</span>
              </div>
            )}
          </div>
          <h3 className="text-sm sm:text-base font-bold text-orange-400">
            {'النادي'}
          </h3>
          <div className="bg-orange-600 text-white text-xs px-2 py-1 rounded-full mt-1">المضيف</div>
        </div>

        {/* VS with Match Time */}
        <div className="text-center">
          <div className="bg-gradient-to-br from-gray-600 to-gray-700 rounded-xl px-3 py-2 sm:px-4 sm:py-3 mb-2">
            <div className="text-orange-400 text-lg sm:text-2xl font-bold">VS</div>
          </div>
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg px-2 py-1 sm:px-3 sm:py-2">
            <div className="text-white text-xs sm:text-sm font-bold">
              {match.time || (isValidDate ? displayDate.toLocaleTimeString('ar-SA', { hour: '2-digit', minute: '2-digit' }) : '20:00')}
            </div>
            <div className="text-blue-100 text-xs">توقيت المباراة</div>
          </div>
        </div>

        {/* Away Team */}
        <div className="text-center">
          <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-2 relative">
            <div className="w-full h-full rounded-full border-2 border-gray-500 bg-gray-700 flex items-center justify-center shadow-lg">
              <span className="text-white text-lg sm:text-xl font-bold">{(match.opponent || match.away_team || 'الضيف').charAt(0)}</span>
            </div>
          </div>
          <h3 className="text-sm sm:text-base font-bold text-gray-300">{match.opponent || match.away_team || 'الفريق الضيف'}</h3>
          <div className="bg-gray-600 text-white text-xs px-2 py-1 rounded-full mt-1">الضيف</div>
        </div>
      </div>

      {/* Two Info Boxes - Venue and Countdown */}
      <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-4">
        {/* Match Venue */}
        <div className="text-center">
          <div className="bg-gradient-to-br from-orange-600 to-orange-700 rounded-xl p-3 sm:p-4 shadow-lg">
            <div className="flex items-center justify-center mb-2">
              <svg className="w-5 h-5 sm:w-6 sm:h-6 text-orange-100" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div className="text-sm sm:text-base font-bold text-white mb-1">المكان</div>
            <div className="text-orange-100 text-xs sm:text-sm font-medium leading-tight">
              {match.venue || match.location || 'ملعب الأمير فيصل بن فهد'}
            </div>
          </div>
        </div>

        {/* Countdown Timer */}
        <div className="text-center">
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl p-3 sm:p-4 shadow-lg">
            <div className="flex items-center justify-center mb-2">
              <svg className="w-5 h-5 sm:w-6 sm:h-6 text-blue-100" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="text-sm sm:text-base font-bold text-white mb-1">العد التنازلي</div>
            <div className="text-blue-100 text-xs sm:text-sm font-medium leading-tight">
              {timeLeft.days > 0 ? `${timeLeft.days} يوم` :
               timeLeft.hours > 0 ? `${timeLeft.hours}:${timeLeft.minutes.toString().padStart(2, '0')}` :
               timeLeft.minutes > 0 ? `${timeLeft.minutes}:${timeLeft.seconds.toString().padStart(2, '0')}` :
               timeLeft.seconds > 0 ? `${timeLeft.seconds} ثانية` : 'بدأت!'}
            </div>
          </div>
        </div>
      </div>

      {/* Match Full Date Display */}
      <div className="text-center">
        <div className="flex items-center justify-center space-x-2 space-x-reverse text-gray-300">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span className="text-sm font-medium">
            {isValidDate 
              ? displayDate.toLocaleDateString('ar-SA', { 
                  weekday: 'long', 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })
              : "الخميس، 27 صفر 1447 هـ"
            }
          </span>
        </div>
      </div>
    </div>
  );
};

// Live Match Countdown Component
const LiveMatchCountdown = ({ matchDate }) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    if (!matchDate) return;

    const updateCountdown = () => {
      const match = new Date(matchDate);
      const now = new Date();
      const difference = match.getTime() - now.getTime();

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
        setIsLive(false);
      } else {
        // Check if match is currently happening (within 2 hours of start time)
        const timeSinceStart = Math.abs(difference);
        if (timeSinceStart <= 2 * 60 * 60 * 1000) { // 2 hours
          setIsLive(true);
        }
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [matchDate]);

  if (isLive) {
    return (
      <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-xl p-6 text-center shadow-2xl animate-pulse">
        <div className="flex items-center justify-center mb-4">
          <div className="w-4 h-4 bg-white rounded-full animate-ping mr-3"></div>
          <span className="text-white text-2xl font-bold">🔴 مباشر الآن</span>
          <div className="w-4 h-4 bg-white rounded-full animate-ping ml-3"></div>
        </div>
        <p className="text-red-100 text-lg font-medium">المباراة جارية حالياً!</p>
      </div>
    );
  }

  if (timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0) {
    return (
      <div className="bg-gradient-to-r from-gray-600 to-gray-700 rounded-xl p-6 text-center shadow-2xl">
        <div className="text-white text-xl font-bold mb-2">⏰ انتهت المباراة</div>
        <p className="text-gray-200">تابعونا للحصول على النتائج</p>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-orange-600 to-orange-700 rounded-xl p-6 shadow-2xl">
      <div className="text-center mb-4">
        <h3 className="text-white text-xl font-bold mb-2">⏰ العد التنازلي للمباراة</h3>
        <p className="text-orange-100 text-sm">الوقت المتبقي حتى بداية المباراة</p>
      </div>
      
      <div className="grid grid-cols-4 gap-2 text-center">
        {/* Days */}
        <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2">
          <div className="text-lg font-bold text-white mb-1">{timeLeft.days}</div>
          <div className="text-orange-100 text-xs font-medium">يوم</div>
        </div>
        
        {/* Hours */}
        <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2">
          <div className="text-lg font-bold text-white mb-1">{timeLeft.hours}</div>
          <div className="text-orange-100 text-xs font-medium">ساعة</div>
        </div>
        
        {/* Minutes */}
        <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2">
          <div className="text-lg font-bold text-white mb-1">{timeLeft.minutes}</div>
          <div className="text-orange-100 text-xs font-medium">دقيقة</div>
        </div>
        
        {/* Seconds */}
        <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2">
          <div className="text-lg font-bold text-white mb-1 animate-pulse">{timeLeft.seconds}</div>
          <div className="text-orange-100 text-xs font-medium">ثانية</div>
        </div>
      </div>
      
      {/* Motivational Message */}
      <div className="mt-4 text-center">
        <p className="text-orange-100 text-sm font-medium">
          {timeLeft.days > 0 ? 
           (() => {
             const matchDay = new Date(matchDate);
             const dayNames = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
             return `يوم ${dayNames[matchDay.getDay()]}`;
           })() :
           timeLeft.hours > 0 ? `أقل من ${timeLeft.hours + 1} ساعة` :
           timeLeft.minutes > 0 ? `أقل من ساعة واحدة` :
           'المباراة على وشك البدء!'}
        </p>
      </div>
    </div>
  );
};

// Loading Component
const LoadingSpinner = ({ message = "جاري التحميل..." }) => (
  <div className="min-h-screen bg-gradient-to-br from-orange-50 to-orange-100 flex items-center justify-center" data-testid="app-loading-screen">
    <div className="text-center">
      <img src="/club-logo-192.png?v=20260915b" alt="تسيار" className="h-14 w-14 mx-auto mb-4 rounded-xl" data-testid="app-loading-logo" />
      <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-orange-600 mx-auto mb-4"></div>
      <p className="text-orange-600 font-medium text-lg">{message}</p>
    </div>
  </div>
);

// Authentication Context
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [platformSettings, setPlatformSettings] = useState({
    platform_name: 'منصة الأندية الرياضية',
    platform_logo: null,
    platform_favicon: null
  });
  const [platformLoading, setPlatformLoading] = useState(true);

  useEffect(() => {
    // جلب إعدادات المنصة أولاً
    const fetchPlatformSettings = async () => {
      try {
        const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
        const response = await axios.get(`${API_BASE_URL}/api/platform/settings`);
        
        if (response.data) {
          setPlatformSettings(response.data);
          // ملاحظة: أيقونة المتصفح (favicon) الافتراضية تبقى ثابتة من أصول public المحلية
          // ولا تُستبدل من إعدادات المنصة/API حفاظاً على ثبات الهوية في التبويب وشاشة التحميل
          console.log('✅ تم جلب إعدادات المنصة بنجاح:', response.data);
        }
      } catch (error) {
        console.error('❌ خطأ في جلب إعدادات المنصة:', error);
      } finally {
        setPlatformLoading(false);
      }
    };

    // التحقق من وجود token في localStorage عند تحميل التطبيق
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    console.log('🔄 فحص حالة الجلسة عند بدء التطبيق:', { hasToken: !!token, hasUserData: !!userData });
    
    // جلب إعدادات المنصة أولاً
    fetchPlatformSettings();
    
    if (token && userData) {
      try {
        const parsedUser = JSON.parse(userData);
        console.log('👤 تم العثور على بيانات المستخدم المحفوظة:', parsedUser);
        
        // إضافة التوكن للـ axios headers
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        // تحديث حالة المستخدم مباشرة
        setUser(parsedUser);
        console.log('✅ تم استعادة الجلسة بنجاح');
        
        // التحقق من صحة التوكن
        checkTokenValidity();
      } catch (error) {
        console.error('❌ خطأ في تحليل بيانات المستخدم المحفوظة:', error);
        logout();
      }
    } else {
      console.log('❌ لا يوجد جلسة محفوظة');
      setLoading(false);
    }
  }, []);

  const checkTokenValidity = async () => {
    try {
      console.log('🔍 فحص صحة التوكن...');
      const token = localStorage.getItem('token');
      console.log('🎟️ التوكن المحفوظ:', token ? `موجود (${token.length} حرف)` : 'مفقود');
      
      if (!token) {
        console.log('❌ لا يوجد توكن للفحص');
        setLoading(false);
        return;
      }
      
      const response = await axios.get(`${API}/auth/me`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      console.log('✅ التوكن صالح:', response.data);
      setUser(response.data);
    } catch (error) {
      console.error('❌ التوكن غير صالح أو منتهي الصلاحية:', error.response?.status);
      
      if (error.response?.status === 401) {
        console.log('🔓 إزالة الجلسة المنتهية الصلاحية');
        logout();
      } else {
        console.error('❌ خطأ في فحص التوكن:', error.message);
        setLoading(false);
      }
    } finally {
      setLoading(false);
    }
  };

  const login = async (username, password) => {
    try {
      console.log('🔑 محاولة تسجيل الدخول للمستخدم:', username);
      
      const response = await axios.post(`${API}/auth/login`, {
        username,
        password
      });
      
      const { access_token, user_info } = response.data;
      console.log('📦 استجابة الخادم:', { access_token: access_token ? 'موجود' : 'مفقود', user_info });
      
      if (!access_token || !user_info) {
        console.log('❌ بيانات الاستجابة ناقصة');
        return { success: false, error: 'بيانات الاستجابة ناقصة' };
      }
      
      // حفظ التوكن ومعلومات المستخدم
      console.log('💾 محاولة حفظ البيانات في localStorage...');
      
      try {
        localStorage.setItem('token', access_token);
        localStorage.setItem('user', JSON.stringify(user_info));
        
        // التحقق من نجاح الحفظ
        const savedToken = localStorage.getItem('token');
        const savedUser = localStorage.getItem('user');
        
        console.log('✅ تم حفظ البيانات في localStorage:', {
          tokenSaved: !!savedToken,
          userSaved: !!savedUser,
          tokenLength: savedToken ? savedToken.length : 0
        });
        
        if (!savedToken || !savedUser) {
          console.error('❌ فشل في حفظ البيانات في localStorage');
          return { success: false, error: 'فشل في حفظ البيانات محلياً' };
        }
      } catch (storageError) {
        console.error('❌ خطأ في الوصول إلى localStorage:', storageError);
        return { success: false, error: 'مشكلة في تخزين البيانات محلياً' };
      }
      
      // إضافة التوكن للـ axios headers
      axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
      console.log('🔗 تم إضافة التوكن لـ axios headers');
      
      // تحديث حالة المستخدم - هذا مهم للتحديث الفوري
      setUser(user_info);
      console.log('👤 تم تحديث حالة المستخدم:', user_info.username);
      
      // تحديث عنوان الصفحة فوراً بعد تسجيل الدخول
      if (user_info.club_name) {
        document.title = `${user_info.club_name} - الموقع الرسمي`;
      }
      
      // Force a delay to ensure React state is updated
      await new Promise(resolve => setTimeout(resolve, 100));
      
      console.log('✅ تم إكمال عملية تسجيل الدخول بنجاح');
      
      return { success: true, user: user_info };
    } catch (error) {
      console.log('❌ خطأ في تسجيل الدخول:', error.response?.data?.detail || error.message);
      return { 
        success: false, 
        error: error.response?.data?.detail || 'خطأ في تسجيل الدخول' 
      };
    }
  };

  const logout = () => {
    // إزالة التوكن ومعلومات المستخدم
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{
      user,
      setUser,
      login,
      logout,
      loading,
      isAuthenticated: !!user,
      platformSettings,
      setPlatformSettings,
      platformLoading,
      setPlatformLoading
    }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// Protected Route Component
const isSuperAdminUser = (user) => !!(user?.is_super_admin || user?.role === 'super_admin');
const isVenueOwnerUser = (user) => user?.club?.account_type === 'venue_owner';

const resolveHomePath = (user) => {
  if (!user) return '/login';
  if (isSuperAdminUser(user)) return '/super-admin';
  if (user.role === 'coach' && !user.club_id) return '/coach';
  if (user.role === 'parent') return '/parent';
  if (isVenueOwnerUser(user)) return '/venue-owner-dashboard';
  return '/dashboard';
};

const ProtectedRoute = ({ children, allow }) => {
  const { user, loading, setUser } = useAuth();

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen gap-4" data-testid="app-loading-screen">
        <img src="/club-logo-192.png?v=20260915b" alt="تسيار" className="h-14 w-14 rounded-xl" data-testid="app-loading-logo" />
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-orange-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.require_email_verification && !user.email_verified) {
    return (
      <MandatoryEmailVerificationGate
        user={user}
        onVerified={setUser}
        onLogout={() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          delete axios.defaults.headers.common['Authorization'];
          window.location.replace('/login');
        }}
      />
    );
  }

  if (allow && !allow(user)) {
    return <Navigate to={resolveHomePath(user)} replace />;
  }

  return children;
};

const NotFoundPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50" dir="rtl" data-testid="not-found-page">
      <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h2 className="text-2xl font-bold text-slate-900">404 — الصفحة غير موجودة</h2>
        <p className="mt-2 text-sm text-slate-500">الرابط الذي حاولت الوصول إليه غير متاح.</p>
        <button onClick={() => navigate(resolveHomePath(user))} className="mt-4 rounded-lg bg-[#16233b] px-6 py-2 text-sm font-semibold text-white" data-testid="not-found-home-btn">العودة للصفحة الرئيسية</button>
      </div>
    </div>
  );
};

// Helper function to get page title by route
const getPageTitleByRoute = (pathname) => {
  const routeTitles = {
    '/': '',
    '/login': 'تسجيل الدخول',
    '/dashboard': 'لوحة التحكم',
    '/super-admin': 'لوحة السوبر أدمن',
    '/players': 'اللاعبين',
    '/teams': 'الفرق',
    '/matches': 'المباريات',
    '/tournaments': 'البطولات',
    '/reports': 'مركز التقارير والتحليلات',
    '/settings': 'الإعدادات'
  };
  
  return routeTitles[pathname] || '';
};

// Helper functions for sections management
const getSectionIcon = (sectionId) => {
  const icons = {
    hero: '🎨',
    achievements: '🏆', 
    news: '📰',
    matches: '⚽',
    tweets: '🐦',
    images: '🖼️'
  };
  return icons[sectionId] || '📋';
};

const getSectionDescription = (sectionId) => {
  const descriptions = {
    hero: 'القسم الرئيسي مع العنوان والوصف وآخر الأخبار',
    achievements: 'إنجازات وإحصائيات النادي',
    news: 'آخر الأخبار والمقالات (مرتبط تلقائياً)',
    matches: 'المباراة القادمة والنتائج (مرتبط تلقائياً)',
    tweets: 'آخر التغريدات من حسابات التويتر',
    images: 'معرض الصور والفيديوهات'
  };
  return descriptions[sectionId] || 'قسم قابل للتخصيص';
};

// Club Public Page Component
const ClubPublicPage = () => {
  // This will be implemented to show public club information
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="text-center py-20">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">صفحة النادي العامة</h1>
        <p className="text-gray-600">سيتم إضافة هذا القسم قريباً</p>
      </div>
    </div>
  );
};

// Login Route Component with Authentication Check
const LoginRoute = ({ onLogin }) => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={resolveHomePath(user)} replace />;
  }

  return <EnhancedProfessionalLogin onLogin={onLogin} />;
};

// حارس صلاحيات على مستوى الصفحة لمسارات المنشأة المقيّدة بأدوار محددة (استقطاب المدربين/تدريبات الفرق/الخطط المشاركة/التقارير الفنية المشتركة/تقييم الأداء)
const RoleGuard = ({ roles, children, allowIf }) => {
  const context = useOutletContext() || {};
  const user = context.user;
  if (!user) return null;
  const roleOk = !roles.length || roles.includes(user.role);
  const extraOk = typeof allowIf === 'function' ? allowIf(user) : false;
  if (!roleOk && !extraOk) {
    return (
      <div className="mx-auto mt-10 max-w-lg rounded-xl border border-slate-200 bg-white p-8 text-center" data-testid="role-guard-denied">
        <p className="text-sm font-semibold text-slate-700">لا تملك صلاحية الوصول إلى هذه الصفحة.</p>
      </div>
    );
  }
  return children;
};

// App Content Component (inside AuthProvider)
const AppContent = ({ clubSettings, clubBasicInfo }) => {
  const { user, setUser } = useAuth();
  const location = useLocation();
  
  // تحديد وضع العنوان (نادي أم منصة)
  const isClubPage = user && !user.is_super_admin && user.role !== 'super_admin';
  const pageTitle = getPageTitleByRoute(location.pathname);

  useEffect(() => {
    if (!location.hash) window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return (
    <>
      {/* إضافة مكون عنوان الصفحة الديناميكي */}
      <DynamicPageTitle pageTitle={pageTitle} clubMode={isClubPage} />
      
      {/* مدير هوية النادي الديناميكية */}
      <ClubIdentityManager clubSettings={clubSettings} clubBasicInfo={clubBasicInfo} />
      
      {/* الأنماط الديناميكية للنادي */}
      <DynamicClubStyles clubSettings={clubSettings} />

      {user && !user.require_email_verification && (
        <EmailVerificationPrompt user={user} onVerified={(updated) => setUser(updated)} />
      )}

      <div className="App">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginRoute onLogin={() => {}} />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/venue-owner/register" element={<RegisterPage />} />
            <Route path="/booking-status/:token" element={<BookingStatusPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/updates" element={<UpdatesPage />} />
            <Route path="/verify/employee/:employeeId" element={<EmployeeVerifyPage />} />

            {/* منظومة المدربين — صفحات عامة */}
            <Route path="/venues" element={<VenuesPublicPage />} />
            <Route path="/coaches" element={<CoachesLandingPage />} />
            <Route path="/coaches/directory" element={<CoachDirectoryPage />} />
            <Route path="/coaches/register" element={<CoachRegisterPage />} />
            <Route path="/contact" element={<ContactUsPage />} />
            <Route path="/parent/invite/:token" element={<ParentInvitePage />} />

            {/* Super Admin Route */}
            <Route path="/super-admin" element={<ProtectedRoute allow={isSuperAdminUser}><SuperAdminPage /></ProtectedRoute>} />
            
            {/* Public Club Pages */}
            <Route path="/club/:clubSlug" element={<ClubPublicPage />} />

            {/* بوابة المدرب المستقلة */}
            <Route element={<ProtectedRoute allow={(u) => u.role === 'coach' && !u.club_id}><CoachShell /></ProtectedRoute>}>
              <Route path="/coach" element={<CoachDashboardPage />} />
              <Route path="/coach/profile" element={<CoachProfilePage />} />
              <Route path="/coach/requests" element={<CoachRequestsPage />} />
              <Route path="/coach/organizations" element={<CoachOrganizationsPage />} />
              <Route path="/coach/crew" element={<CoachCrewPage />} />
              <Route path="/coach/studio" element={<StudioDashboardPage />} />
              <Route path="/coach/studio/exercises" element={<ExerciseLibraryPage />} />
              <Route path="/coach/studio/exercises/new" element={<ExerciseEditorPage />} />
              <Route path="/coach/studio/exercises/:id" element={<ExerciseEditorPage />} />
              <Route path="/coach/studio/plans" element={<TrainingPlansPage />} />
              <Route path="/coach/studio/plans/:id" element={<PlanDetailPage />} />
              <Route path="/coach/studio/schedule" element={<TrainingSchedulePage />} />
              <Route path="/coach/studio/reports" element={<StudioReportsPage />} />
            </Route>

            {/* بوابة ولي الأمر المستقلة */}
            <Route element={<ProtectedRoute allow={(u) => u.role === 'parent'}><ParentShell /></ProtectedRoute>}>
              <Route path="/parent" element={<ParentHomePage />} />
              <Route path="/parent/children" element={<ParentChildrenPage />} />
              <Route path="/parent/children/:playerId" element={<ParentChildDetailPage />} />
              <Route path="/parent/explore" element={<ParentExplorePage />} />
              <Route path="/parent/payments" element={<ParentPaymentsPage />} />
              <Route path="/parent/account" element={<ParentAccountPage />} />
            </Route>
            
            {/* Protected Organization Routes - قالب موحد OrganizationShell/OrganizationLayout */}
            <Route element={
              <ProtectedRoute allow={(u) => !isSuperAdminUser(u) && u.role !== 'parent' && !(u.role === 'coach' && !u.club_id) && !isVenueOwnerUser(u)}>
                <OrganizationShell />
              </ProtectedRoute>
            }>
            <Route path="/dashboard" element={<OrganizationDashboard />} />
            <Route path="/coach-recruitment" element={<RoleGuard roles={['admin', 'manager']}><CoachRecruitmentPage /></RoleGuard>} />
            <Route path="/shared-coaching" element={<RoleGuard roles={['admin', 'manager']}><SharedCoachingHubPage /></RoleGuard>} />
            <Route path="/activity-log" element={<ActivityLogPage />} />
            <Route path="/board-of-directors" element={<BoardPage />} />
          
          <Route path="/categories" element={<Navigate to="/teams?view=categories" replace />} />
          
          <Route path="/players" element={<PlayersPage />} />
          <Route path="/subscription" element={<SubscriptionPlansPage />} />
          <Route path="/venue-booking" element={<VenueManagementPage />} />
          
          <Route path="/teams" element={<TeamsPage />} />
          
          <Route path="/matches" element={<MatchesPage />} />

          <Route path="/tournaments" element={<TournamentsPage />} />

          <Route path="/reports" element={<ReportsPage />} />
          
          <Route path="/scorers" element={<Navigate to="/players" replace />} />
          
          <Route path="/governance-strategy-pro" element={<GovernancePage />} />
          
          <Route path="/help" element={<HelpCenterPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/support/:id" element={<SupportTicketDetailPage />} />
          
          <Route path="/achievements" element={<Navigate to="/governance-strategy-pro" replace />} />
          
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />

          {/* Staff Management Routes - وحدة موظفين موحدة بتبويبات، المسارات القديمة تفتح التبويب المناسب */}
          <Route path="/staff-admin" element={<EmployeesPage initialType="all" />} />
          
          <Route path="/coaching-staff" element={<EmployeesPage initialType="coach" />} />
          
          <Route path="/medical-staff" element={<EmployeesPage initialType="medical" />} />
          
          <Route path="/security-staff" element={<EmployeesPage initialType="security" />} />
          
          <Route path="/general-services" element={<EmployeesPage initialType="services" />} />
          
          <Route path="/attendance" element={<AttendancePage />} />
          
          <Route path="/performance-review" element={<RoleGuard roles={['admin', 'manager']}><PerformanceReviewPage /></RoleGuard>} />

          {/* Financial Management Routes */}
          <Route path="/finance" element={<FinanceHubPage />} />
          <Route path="/accounts" element={<FinanceSummaryPage />} />
          
          <Route path="/expenses" element={<TransactionsPage kind="expense" />} />
          
          <Route path="/revenues" element={<TransactionsPage kind="revenue" />} />
          
          <Route path="/payroll" element={<PayrollPage />} />
          
          <Route path="/budget" element={<BudgetPage />} />
          
          <Route path="/financial-reports" element={<FinanceReportsPage />} />
          
          <Route path="/invoices" element={<InvoicesPage />} />
          
          <Route path="/quotes" element={<QuotesPage />} />
          <Route path="/parent-link-requests" element={<RoleGuard roles={['admin', 'manager']}><ParentLinkRequestsPage /></RoleGuard>} />
          <Route path="/communication" element={<RoleGuard roles={['admin', 'manager']} allowIf={(u) => !!u.can_communicate}><CommunicationPage /></RoleGuard>} />
          <Route path="/programs" element={<RoleGuard roles={['admin', 'manager']}><ProgramsPage /></RoleGuard>} />
          </Route>

          {/* لوحة تسيار للملاعب — حسابات venue_owner المستقلة */}
          <Route element={<ProtectedRoute allow={isVenueOwnerUser}><VenueOwnerShell /></ProtectedRoute>}>
            <Route path="/venue-owner-dashboard" element={<VenueOwnerHomePage />} />
            <Route path="/venue-owner-dashboard/bookings" element={<VenueOwnerBookingsPage />} />
            <Route path="/venue-owner-dashboard/calendar" element={<VenueOwnerCalendarPage />} />
            <Route path="/venue-owner-dashboard/venues" element={<VenueOwnerVenuesPage />} />
            <Route path="/venue-owner-dashboard/customers" element={<VenueOwnerCustomersPage />} />
            <Route path="/venue-owner-dashboard/reports" element={<VenueOwnerReportsPage />} />
            <Route path="/venue-owner-dashboard/notifications" element={<VenueOwnerNotificationsPage />} />
            <Route path="/venue-owner-dashboard/public-page" element={<VenueOwnerPublicPagePage />} />
            <Route path="/venue-owner-dashboard/subscription" element={<VenueOwnerSubscriptionPage />} />
            <Route path="/venue-owner-dashboard/settings" element={<VenueOwnerSettingsPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </Suspense>
      </div>

      {/* Chat Widget — يظهر فقط للمستخدمين المسجّلين، ومخفي في بوابة ولي الأمر لتجربة تطبيق نظيفة */}
      {user && !location.pathname.startsWith('/parent') && (
        <ChatWidget user={user} clubSettings={clubSettings} hideFloatingButtonMobile={location.pathname.startsWith('/coach')} pathname={location.pathname} />
      )}
      {/* أسئلة شائعة بلا AI — للزوار غير المسجّلين دخول فقط */}
      {!user && !location.pathname.startsWith('/parent') && <PublicFaqWidget />}
    </>
  );
};

// Main App Component
function App() {
  const [clubSettings, setClubSettings] = useState(null);

  useEffect(() => {
    // Apply saved font on app load
    const savedFont = localStorage.getItem('arabicFont') || 'Cairo';
    const style = document.createElement('style');
    style.textContent = `
      * {
        font-family: '${savedFont}', system-ui, -apple-system, sans-serif !important;
      }
      body, html, #root, .App {
        font-family: '${savedFont}', system-ui, -apple-system, sans-serif !important;
      }
      input, textarea, select, button {
        font-family: '${savedFont}', system-ui, -apple-system, sans-serif !important;
      }
    `;
    const existingStyle = document.getElementById('arabic-font-style');
    if (existingStyle) {
      existingStyle.remove();
    }
    style.id = 'arabic-font-style';
    document.head.appendChild(style);

    // Set dynamic title for public page
    const updatePublicTitle = () => {
      const userData = localStorage.getItem('user');
      let clubName = 'النادي';
      
      try {
        if (userData) {
          const user = JSON.parse(userData);
          clubName = user.club_name || 'النادي';
        }
      } catch (error) {
        console.error('خطأ في قراءة بيانات المستخدم:', error);
      }
      
      document.title = `${clubName} - الموقع الرسمي`;
    };
    
    // Set initial title
    updatePublicTitle();
    
    // Update title when data changes
    
    window.addEventListener('logoUpdated', updatePublicTitle);
    window.addEventListener('refreshPublicData', updatePublicTitle);

    // Fetch club settings
    const fetchClubSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/club-info`);
        if (response.ok) {
          const settings = await response.json();
          setClubSettings(settings);
        }
      } catch (error) {
        console.error('Error fetching club settings:', error);
      }
    };

    fetchClubSettings();
  }, []);

  const handleLoginSuccess = (userData) => {
    // This function will be called when ProfessionalLogin succeeds
    console.log('Login successful, user data:', userData);
    // The authentication state will be updated by the ProfessionalLogin component
    // via the AuthContext when it stores the token and calls login()
  };

  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent clubSettings={clubSettings} />
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  );
}



export default App;